// // import React, { useState, useEffect, useCallback, useRef } from 'react';
// // import { Link, useParams, useLocation } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import {
// //   MdSearch,
// //   MdYoutubeSearchedFor,
// //   MdZoomIn,
// //   MdZoomOut,
// //   MdFullscreen,
// //   MdFullscreenExit,
// //   MdPrint,
// //   MdChevronLeft,
// //   MdChevronRight,
// //   MdClose,
// //   MdEmail,
// //   MdHome,
// //   // MdStar,
// //   MdStarOutline,
// //   MdPictureAsPdf,
// // } from 'react-icons/md';

// // import { GiSandsOfTime } from 'react-icons/gi';

// // import { components } from 'react-select';

// // // import { border, borderRadius } from 'polished';
// // // import { borderRadius, padding } from 'polished';
// // import { toast } from 'react-toastify';
// // import api from '../../../services/api';
// // import history from '../../../services/history';

// // import { AppError } from '../../../errors/AppError';

// // import {
// //   opEmpresa,
// //   // opSimNao,
// //   opTipoAcao,
// //   opTipoAcesso,
// // } from '../../../lib/const';
// // import { debounce } from '../../../lib/inputUtils';
// // import { initialParams } from '../../../lib/reactRouter';
// // import { getMaterial, getArranjo } from '../../../lib/asyncUtils';

// // import TreeView from '../../../components/TreeView';

// // import { Form } from '../../../components/Form';
// // import AsyncSelect from '../../../components/Form/Input/AsyncSelect';
// // import { Info } from '../../../components/Info';

// // import Listagem from './Listagem';
// // import Page from './Pagina';

// // import {
// //   Container,
// //   Wrapper,
// //   Menu,
// //   Content,
// //   WrapperTitleInfo,
// //   WrapperSubtitles,
// //   WrapperTittleInfoSubtitle,
// //   BtnFilter,
// // } from './styles';
// // import {
// //   handleHomeFilter,
// //   handleHomeFilterClear,
// // } from '../../../store/modules/homeFilter/actions';
// // import HoverImagePortal from '../../../components/HoverImagePortal';
// // import {
// //   adicionaCarrinhoArrayRequest,
// //   sharedManagementSet,
// // } from '../../../store/modules/cart/actions';
// // import Dictaphone from '../../../components/SpeechRecognition';
// // import {
// //   useDictaphone,
// //   utilizaVisualizaoFacesSistema,
// //   usaIdiomaCatalogo,
// //   usaPdfCatalogoCdi,
// // } from '../../../lib/paramUtils';
// // import { setIdiomaCatalogo } from '../../../store/modules/param/actions';
// // import IdiomaCatalogoSelect from '../../../components/IdiomaCatalogoSelect';
// // import SearchAutocomplete from '../../../components/Form/Input/SearchAutocomplete';
// // import SistemaFacesTree from '../../../components/SistemaFacesTree';

// // function Classificacao() {
// //   const { id } = useParams();
// //   const location = useLocation();

// //   const dictaphoneEnabled = useDictaphone();

// //   const { app, action, signed, token } = useSelector(
// //     (state) => state.auth || {}
// //   );
// //   const { adm, empresa } = useSelector((state) => state.user.profile || {});
// //   const { homeFilter } = useSelector((state) => state || {});
// //   const { sharedManagement } = useSelector((state) => state.cart || {});

// //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
// //   const idiomaCatalogo = useSelector(
// //     (state) => state.param.idiomaCatalogo || null
// //   );
// //   const exibeIdiomaCatalogo = usaIdiomaCatalogo();
// //   const exibePdfCatalogoCdi = usaPdfCatalogoCdi();

// //   /** params de idioma para as chamadas (vazio quando não escolhido) */
// //   const idiomaParams =
// //     idiomaCatalogo !== null ? { idioma: idiomaCatalogo } : {};

// //   /** referencia para atribuir controles de zoom */
// //   const zoomInRef = useRef();
// //   const zoomOutRef = useRef();
// //   const zoomResetRef = useRef();

// //   const formRef = useRef();
// //   const paginaRef = useRef();

// //   const refTtreeView = useRef(null);

// //   const dispatch = useDispatch();

// //   const [menuHidden, setMenuHidden] = useState(false);
// //   const [menuFacesHidden, setMenuFacesHidden] = useState(false);
// //   const [pageMaximize, setPageMaximize] = useState(false);

// //   const [catalogo, setCatalogo] = useState(null);
// //   const [paginaCatalogo, setPaginaCatalogo] = useState([]);
// //   const [controle, setControle] = useState(false);
// //   const [shownPage, setShownPage] = useState(0);
// //   const [nSerie, setNSerie] = useState([]);
// //   const [catalogoPdf, setCatalogoPdf] = useState(null);

// //   const [loadingButtonPrint, setLoadingButtonPrint] = useState(false);
// //   const [loadingButtonMail, setLoadingButtonMail] = useState(false);

// //   const [fmtFilterSearch, setFmtFilterSearch] = useState([]);

// //   const [valueAsyncSelect, setValueAsyncSelect] = useState('');

// //   const [isHovered, setIsHovered] = useState(null);

// //   const [speechTranscript, setSpeechTranscript] = useState('');

// //   const selectMaterialRef = useRef(null);
// //   const [selectedOption, setSelectedOption] = useState(null);
// //   // const [valueAsyncSelect, setValueAsyncSelect] = useState('');
// //   const [isEditing, setIsEditing] = useState(false);
// //   const prevQRef = useRef('');

// //   useEffect(() => {
// //     const q = new URLSearchParams(location.search).get('q') || '';
// //     if (q !== prevQRef.current) {
// //       setValueAsyncSelect(q);
// //       // Se ainda não existe seleção real, mantém o "valor sintético" para exibir o texto
// //       setSelectedOption((curr) => {
// //         if (!q) return null;
// //         if (!curr || curr.__isTyped) {
// //           return { value: '__typed__', label: q, __isTyped: true };
// //         }
// //         return curr; // mantém a seleção real
// //       });
// //       prevQRef.current = q;
// //     }
// //   }, [location.search]);

// //   useEffect(() => {
// //     api
// //       .get(`/catalogo-navegacao/${id}/pagina`, {
// //         params: { ...idiomaParams },
// //       })
// //       .then((response) => {
// //         setPaginaCatalogo(response.data);
// //       });
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [id, idiomaCatalogo]);

// //   useEffect(() => {
// //     if (Array.isArray(homeFilter.paginas) && homeFilter.paginas.length > 0) {
// //       setFmtFilterSearch(
// //         paginaCatalogo.filter((i) =>
// //           homeFilter.paginas.some((j) => i.idPagina === j.idPagina)
// //         )
// //       );
// //     } else {
// //       setFmtFilterSearch(paginaCatalogo);
// //     }
// //   }, [paginaCatalogo, homeFilter]);

// //   useEffect(() => {
// //     /** pega parâmetros da rota */
// //     const paramQuery = new URLSearchParams(location.search);

// //     const paramRoute = {
// //       ...initialParams,
// //       ...Object.fromEntries(paramQuery),
// //     };

// //     api
// //       .get(`/catalogo-navegacao/${id}`, {
// //         params: {
// //           ...paramRoute,
// //           ...idiomaParams,
// //         },
// //       })
// //       .then((response) => {
// //         setCatalogo(response.data);

// //         /** Preenchimento do campos arranjo */
// //         const { arranjo } = response.data;

// //         if (arranjo && formRef.current) {
// //           const valorAtual = formRef.current.getFieldValue('idArranjo');
// //           if (!valorAtual) {
// //             formRef.current.setFieldValue('idArranjo', {
// //               label: `N/S: ${arranjo.numeroSerie} - ${arranjo.nome}`,
// //               value: `${arranjo.idSerie}.${arranjo.idArranjo}`,
// //             });
// //           }
// //         }
// //       })
// //       .catch((err) => {
// //         AppError(err);
// //       });
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [id, location, idiomaCatalogo]);

// //   useEffect(() => {
// //     api
// //       .get(`/catalogo/${id}`)
// //       .then((response) => {
// //         setCatalogoPdf(response.data.arquivo.url);
// //         setNSerie(response.data.series || []);
// //       })
// //       .catch((err) => {
// //         AppError(err);
// //       });
// //   }, [id]);

// //   useEffect(() => {
// //     /** pega parâmetros da rota */
// //     const paramQuery = new URLSearchParams(location.search);

// //     setControle(paramQuery.has('IDP'));
// //     if (catalogo && paramQuery.has('IDP')) {
// //       const page = Number(paramQuery.get('IDP'));

// //       const { paginas = [] } = catalogo;

// //       const index = paginas.findIndex((p) => p === page);
// //       if (index >= 0) setShownPage(index + 1);

// //       if (homeFilter.value !== null) {
// //         const indexHomeFilter = fmtFilterSearch.findIndex(
// //           (p) => p.idPagina === page
// //         );
// //         if (indexHomeFilter >= 0) setShownPage(indexHomeFilter + 1);
// //       }
// //     }
// //   }, [location, catalogo, homeFilter, fmtFilterSearch]);

// //   // const handleFiltroAsyncSelect = useCallback(
// //   //   (value) => {
// //   //     api
// //   //       .get(`/catalogo-filtro/${id}/material-catalogo`, {
// //   //         params: {
// //   //           q: value,
// //   //         },
// //   //       })
// //   //       .then((response) => {
// //   //         const { searchHandle, paginas, paginasERP } = response.data;

// //   //         // console.log(value);

// //   //         dispatch(handleHomeFilter(value, searchHandle, paginas, paginasERP));
// //   //       })
// //   //       .catch((error) => {
// //   //         console.error('Erro ao filtrar:', error);
// //   //       })
// //   //       .finally(() => {
// //   //         // setValueAsyncSelect(null);
// //   //         // setValueAsyncSelect('');
// //   //         // history.push(`/catalogo.partes/${id}`);
// //   //         history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);
// //   //       });

// //   //     // history.push(`/catalogo.partes/${id}`);
// //   //   },
// //   //   [id, dispatch]
// //   // );

// //   // const handleFiltroAsyncSelect = useCallback(
// //   //   (value) => {
// //   //     api
// //   //       .get(`/catalogo-filtro/${id}/material-catalogo`, {
// //   //         params: { q: value },
// //   //       })
// //   //       .then((response) => {
// //   //         const { searchHandle, paginas, paginasERP } = response.data;
// //   //         dispatch(handleHomeFilter(value, searchHandle, paginas, paginasERP));
// //   //       })
// //   //       .catch((error) => console.error('Erro ao filtrar:', error))
// //   //       .finally(() => {
// //   //         history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);
// //   //         setTimeout(() => {
// //   //           try {
// //   //             const el = selectMaterialRef.current;
// //   //             if (el && typeof el.focus === 'function') {
// //   //               el.focus();
// //   //             }
// //   //           } catch (err) {
// //   //             console.error('Erro ao devolver foco:', err);
// //   //           }
// //   //         }, 0);
// //   //       });
// //   //   },
// //   //   [id, dispatch]
// //   // );

// //   const handleFiltroAsyncSelect = useCallback(
// //     (value) => {
// //       api
// //         .get(`/catalogo-filtro/${id}/material-catalogo`, {
// //           params: { q: value, ...idiomaParams },
// //         })
// //         .then((response) => {
// //           const {
// //             searchHandle,
// //             paginas,
// //             paginasERP,
// //             avisosPartnumber = [],
// //           } = response.data;

// //           dispatch(
// //             handleHomeFilter(
// //               value,
// //               searchHandle,
// //               paginas,
// //               paginasERP,
// //               avisosPartnumber
// //             )
// //           );

// //           if (avisosPartnumber.length === 1) {
// //             const aviso = avisosPartnumber[0];

// //             toast.info(
// //               `O partnumber ${aviso.partnumberPesquisado} foi encontrado no histórico, mas o atual agora é ${aviso.partnumberAtual}.`
// //             );
// //           }

// //           if (avisosPartnumber.length > 1) {
// //             toast.info(
// //               `${avisosPartnumber.length} itens encontrados possuem partnumber atualizado. Veja os avisos na tela.`
// //             );
// //           }
// //         })
// //         .catch((error) => console.error('Erro ao filtrar:', error))
// //         .finally(() => {
// //           history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);

// //           setTimeout(() => {
// //             try {
// //               const el = selectMaterialRef.current;
// //               if (el && typeof el.focus === 'function') {
// //                 el.focus();
// //               }
// //             } catch (err) {
// //               console.error('Erro ao devolver foco:', err);
// //             }
// //           }, 0);
// //         });
// //     },
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //     [id, dispatch, idiomaCatalogo]
// //   );

// //   const handleAbrirPdfCatalogo = useCallback(() => {
// //     api
// //       .get(`/pdf-catalogo/${id}`)
// //       .then((response) => {
// //         const { existe, url, mensagem } = response.data || {};

// //         if (existe && url) {
// //           window.open(url, '_blank');
// //         } else {
// //           toast.warn(mensagem || 'O catálogo não foi gerado.');
// //         }
// //       })
// //       .catch(() => {
// //         toast.error('Não foi possível verificar o PDF do catálogo.');
// //       });
// //   }, [id]);

// //   // const handleFiltroPaginas = useCallback(() => {
// //   //   // const { value, searchHandle, paginas, paginasERP } = homeFilter;

// //   //   // console.log(value, searchHandle, paginas, paginasERP);

// //   //   // levar para pagina de busca das páginas com o value pesquisado
// //   //   // history.push(`/catalogo.partes/${id}/paginas-filtro`);

// //   //   console.log('TESTE');
// //   // }, [history, id]);

// //   const handlePagina = useCallback(
// //     (data) => {
// //       // const { value = '' } = data || {};
// //       const { value = '', label = {} } = data || {};
// //       const [, idPagina] = value.split('.');

// //       if (idPagina) {
// //         const { niveis = [] } =
// //           paginaCatalogo.find((p) => p.idPagina === Number(idPagina)) || {};

// //         const searchLocation = [];

// //         /** processa os níveis da página */
// //         // niveis.forEach((itemNivel) => {
// //         //   searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
// //         // });

// //         /** mantém os filtros já aplicados antes de abrir a página do item */
// //         const paramQuery = new URLSearchParams(location.search);
// //         ['FLT_IDS', 'FLT_IDL', 'FLT_IDE', 'FLT_IDA'].forEach((key) => {
// //           const paramValue = paramQuery.get(key);
// //           if (paramValue) searchLocation.push(`${key}=${paramValue}`);
// //         });

// //         /**
// //          * Usa a hierarquia retornada pela própria busca quando disponível.
// //          * Isso evita abrir a página com IDN incompleto/incorreto e mantém
// //          * a árvore de Faces do Sistema limitada ao sistema da página clicada.
// //          */
// //         if (label.paginaNivelURL) {
// //           searchLocation.push(label.paginaNivelURL);
// //         } else {
// //           niveis.forEach((itemNivel) => {
// //             searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
// //           });
// //         }

// //         /** processa página */
// //         searchLocation.push(`IDP=${idPagina}`);
// //         /** processa item */
// //         // searchLocation.push(`IDI=${data.value}`);
// //         searchLocation.push(`IDI=${value}`);

// //         /** Adiciona materila ERP URL para ser filtrado e selecionado no ItemCart */
// //         // if (data.label.codimate) {
// //         //   searchLocation.push(`ERP=${data.label.codimate}`);
// //         // }

// //         /** Adiciona material ERP na URL para ser selecionado no ItemCart */
// //         if (label.codimate) {
// //           searchLocation.push(`ERP=${label.codimate}`);
// //         }

// //         history.push(`${id}?${searchLocation.join('&')}`);

// //         // devolve o foco para continuar exibindo o texto digitado
// //         setTimeout(() => {
// //           try {
// //             const el = selectMaterialRef.current;
// //             if (el && typeof el.focus === 'function') el.focus();
// //           } catch (err) {
// //             console.error('Erro ao devolver foco:', err);
// //           }
// //         }, 0);
// //       }
// //     },
// //     // [id, paginaCatalogo]
// //     [id, paginaCatalogo, location.search]
// //   );

// //   const handleSerieArranjo = useCallback(
// //     (data) => {
// //       const params = [];

// //       /** separa valores "serie.arranjo" */
// //       const { value = '' } = data || {};
// //       const [serie, arranjo] = value.split('.');

// //       /** pega parâmetros da rota */
// //       const paramQuery = new URLSearchParams(location.search);
// //       const paramRoute = {
// //         ...initialParams,
// //         ...Object.fromEntries(paramQuery),
// //       };

// //       /** processa os parâmetros de sistema e local caso eles existam no primeiro ciclo */
// //       const { FLT_IDS: fltIdS, FLT_IDL: fltIdL } = paramRoute;
// //       if (fltIdS) params.push(`FLT_IDS=${fltIdS}`);
// //       if (fltIdL) params.push(`FLT_IDL=${fltIdL}`);

// //       /** processa arranjo */
// //       if (serie && arranjo) {
// //         params.push(`FLT_IDE=${serie}`);
// //         params.push(`FLT_IDA=${arranjo}`);
// //       }

// //       /** monta rota para redirecionamento */
// //       const routeParam = `?${params.join('&')}`;

// //       if (location.search !== routeParam)
// //         history.push(location.pathname + routeParam);
// //     },
// //     [location]
// //   );

// //   // const handlePageNavFilter = useCallback((step) => {
// //   //   if (homeFilter.value !== null) {
// //   //     const currentPage = paginaCatalogo[shownPage - 1];

// //   //     console.log(currentPage);

// //   //     const indexCurrentPage = fmtFilterSearch.indexOf(
// //   //       fmtFilterSearch.find((i) => i.idPagina === currentPage.idPagina)
// //   //     );

// //   //     console.log('indexCurrentPage...', indexCurrentPage);
// //   //     console.log(
// //   //       'fmtFilterSearch[indexCurrentPage + step]...',
// //   //       fmtFilterSearch[indexCurrentPage + step]
// //   //     );

// //   //     if (fmtFilterSearch[indexCurrentPage + step] === undefined) return;

// //   //     const { idPagina, niveis } = fmtFilterSearch[indexCurrentPage + step];
// //   //     const { idCatalogo } = catalogo;

// //   //     const searchLocation = [];

// //   //     niveis.forEach((itemNivel) => {
// //   //       searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
// //   //     });

// //   //     searchLocation.push(`IDP=${idPagina}`);

// //   //     history.push(`${idCatalogo}?${searchLocation.join('&')}`);
// //   //   }
// //   // }, []);

// //   const handlePageNav = useCallback(
// //     (step) => {
// //       if (catalogo && step !== 0) {
// //         const nextPage = shownPage - 1 + step;

// //         // console.log('\n paginaCatalogo...', paginaCatalogo);
// //         // console.log('homeFilter...', homeFilter);
// //         // console.log('fmtFilterSearch...', fmtFilterSearch);

// //         // console.log('shownPage, step...', shownPage, step);
// //         // console.log(
// //         //   'nextPage, fmtFilterSearch.length...',
// //         //   nextPage,
// //         //   fmtFilterSearch.length
// //         // );

// //         if (homeFilter.value !== null) {
// //           const currentPage = fmtFilterSearch[shownPage - 1];

// //           // console.log(currentPage);

// //           const indexCurrentPage = fmtFilterSearch.indexOf(
// //             fmtFilterSearch.find((i) => i.idPagina === currentPage.idPagina)
// //           );

// //           // console.log('indexCurrentPage...', indexCurrentPage);
// //           // console.log(
// //           //   'fmtFilterSearch[indexCurrentPage + step]...',
// //           //   fmtFilterSearch[indexCurrentPage + step]
// //           // );

// //           if (fmtFilterSearch[indexCurrentPage + step] === undefined) return;

// //           const { idPagina, niveis } = fmtFilterSearch[indexCurrentPage + step];
// //           const { idCatalogo } = catalogo;

// //           const searchLocation = [];

// //           niveis.forEach((itemNivel) => {
// //             searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
// //           });

// //           searchLocation.push(`IDP=${idPagina}`);

// //           history.push(`${idCatalogo}?${searchLocation.join('&')}`);
// //         }

// //         /** Navega para a página encontrada */
// //         if (
// //           homeFilter.value === null &&
// //           nextPage >= 0 &&
// //           nextPage < paginaCatalogo.length
// //         ) {
// //           const { idPagina, niveis } = paginaCatalogo[nextPage];

// //           const { idCatalogo, paginas = [] } = catalogo;

// //           /** verifica se a página não está filtrada */
// //           if (paginas.find((p) => p === idPagina)) {
// //             const searchLocation = [];

// //             /** pega parâmetros da rota */
// //             const paramQuery = new URLSearchParams(location.search);
// //             const paramRoute = {
// //               ...initialParams,
// //               ...Object.fromEntries(paramQuery),
// //             };

// //             /** processa os parâmetros de sistema, local e pesquisa caso eles existam no primeiro ciclo */
// //             const {
// //               FLT_IDS: fltIdS,
// //               FLT_IDL: fltIdL,
// //               FLT_IDE: fltIdE,
// //               FLT_IDA: fltIdA,
// //               q: fltSearch,
// //             } = paramRoute;
// //             if (fltIdS) searchLocation.push(`FLT_IDS=${fltIdS}`);
// //             if (fltIdL) searchLocation.push(`FLT_IDL=${fltIdL}`);
// //             if (fltIdE) searchLocation.push(`FLT_IDE=${fltIdE}`);
// //             if (fltIdA) searchLocation.push(`FLT_IDA=${fltIdA}`);
// //             if (fltSearch) searchLocation.push(`q=${fltSearch}`);

// //             /** processa os níveis da página */
// //             niveis.forEach((itemNivel) => {
// //               searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
// //             });

// //             /** processa página */
// //             searchLocation.push(`IDP=${idPagina}`);

// //             /** monta rota para redirecionamento */
// //             history.push(`${idCatalogo}?${searchLocation.join('&')}`);
// //           }
// //         }
// //       }
// //     },
// //     [location, catalogo, paginaCatalogo, shownPage, fmtFilterSearch, homeFilter]
// //   );

// //   // const handleImprimir = useCallback(() => {
// //   //   /** chama função de impressão do componente filho */
// //   //   if (paginaRef.current) {
// //   //     paginaRef.current.handleImprimirPagina();
// //   //   }
// //   // }, []);

// //   const handlePDF = useCallback(async () => {
// //     setLoadingButtonPrint(true);
// //     /** chama função de impressão do componente filho */
// //     if (paginaRef.current) {
// //       paginaRef.current.handleImprimirPagina(false, setLoadingButtonPrint);
// //     }
// //   }, []);

// //   const handleMail = useCallback(() => {
// //     setLoadingButtonMail(true);
// //     /** chama função de impressão do componente filho */
// //     if (paginaRef.current) {
// //       paginaRef.current.handleImprimirPagina(true, setLoadingButtonMail);
// //     }
// //   }, []);

// //   const handleRedimensionar = useCallback(() => {
// //     setPageMaximize((state) => !state);

// //     /** chama função de redimensionamento do componente filho */
// //     if (paginaRef.current) {
// //       paginaRef.current.handleRedimensionarPagina(!pageMaximize);
// //     }
// //   }, [pageMaximize]);

// //   const handleFiltro = useCallback(
// //     (key) => {
// //       dispatch(handleHomeFilterClear());
// //       /** pega parâmetros da rota */
// //       const paramQuery = new URLSearchParams(location.search);

// //       const params = [];
// //       paramQuery.forEach((param, index) => {
// //         if (index !== key) {
// //           params.push(`${index}=${param}`);
// //         }
// //       });

// //       const routeParam = `?${params.join('&')}`;

// //       history.push(location.pathname + routeParam);
// //     },
// //     [location, dispatch]
// //   );

// //   const handleBreadcrumb = useCallback(
// //     (data) => {
// //       const breadcrumbs = [];
// //       const url = [];

// //       /** pega parâmetros da rota */
// //       const paramQuery = new URLSearchParams(location.search);
// //       const paramRoute = {
// //         ...initialParams,
// //         ...Object.fromEntries(paramQuery),
// //       };

// //       /** processa os parâmetros de sistema, local e pesquisa caso eles existam */
// //       const {
// //         FLT_IDS: fltIdS,
// //         FLT_IDL: fltIdL,
// //         FLT_IDE: fltIdE,
// //         FLT_IDA: fltIdA,
// //         q: fltSearch,
// //       } = paramRoute;
// //       if (fltIdS) url.push(`FLT_IDS=${fltIdS}`);
// //       if (fltIdL) url.push(`FLT_IDL=${fltIdL}`);
// //       if (fltIdE) url.push(`FLT_IDE=${fltIdE}`);
// //       if (fltIdA) url.push(`FLT_IDA=${fltIdA}`);
// //       if (fltSearch) url.push(`q=${fltSearch}`);

// //       const { idCatalogo, nome, treeView } = data;

// //       breadcrumbs.push({
// //         name: nome,
// //         url:
// //           url.length > 0 ? `${idCatalogo}?${url.join('&')}` : `${idCatalogo}`,
// //       });

// //       let currNode = treeView;

// //       Object.keys(paramRoute).forEach((paramAtual) => {
// //         /** monta breadcrumb */
// //         if (paramAtual.startsWith('IDN_') || paramAtual.startsWith('IDP')) {
// //           const [, key] = paramAtual.split('_');

// //           /** monta url para acesso */
// //           url.push(`${paramAtual}=${paramRoute[paramAtual]}`);

// //           const itemNode = currNode.find(
// //             (n) =>
// //               n.codigo === (Number(key) || idCatalogo) &&
// //               n.id === Number(paramRoute[paramAtual])
// //           );

// //           if (itemNode) {
// //             const { descricao } = itemNode;

// //             breadcrumbs.push({
// //               name: descricao,
// //               url: `?${url.join('&')}`,
// //             });

// //             /** atualiza item da treeview */
// //             if (itemNode.itens) currNode = itemNode.itens;
// //           }
// //         }
// //       });

// //       const { name = '' } = breadcrumbs[breadcrumbs.length - 1] || {};

// //       return (
// //         <Content.ToolBar.Header>
// //           {homeFilter.value && (
// //             <div>
// //               <h5>Filtrado por: </h5>
// //               <span>{homeFilter.value}</span>
// //               <button
// //                 type="button"
// //                 title="Limpar filtro"
// //                 onClick={() => {
// //                   dispatch(handleHomeFilterClear());
// //                   history.push(`/catalogo.partes/${id}`);
// //                 }}
// //               >
// //                 <MdClose size={20} />
// //               </button>
// //             </div>
// //           )}
// //           {Array.isArray(homeFilter.avisosPartnumber) &&
// //             homeFilter.avisosPartnumber.length > 0 && (
// //               <div
// //                 style={{
// //                   marginTop: 8,
// //                   marginBottom: 8,
// //                   padding: '10px 12px',
// //                   border: '1px solid #f59e0b',
// //                   borderRadius: 8,
// //                   background: '#fffbeb',
// //                   color: '#92400e',
// //                   fontSize: 13,
// //                   lineHeight: 1.4,
// //                 }}
// //               >
// //                 <strong>Partnumber atualizado:</strong>

// //                 {homeFilter.avisosPartnumber.slice(0, 3).map((aviso) => (
// //                   <div
// //                     key={`${aviso.idMaterial}-${aviso.idPagina}-${aviso.idItem}`}
// //                   >
// //                     O partnumber pesquisado{' '}
// //                     <strong>{aviso.partnumberPesquisado}</strong> pertence ao
// //                     histórico deste item, mas o partnumber atual agora é{' '}
// //                     <strong>{aviso.partnumberAtual}</strong>.
// //                   </div>
// //                 ))}

// //                 {homeFilter.avisosPartnumber.length > 3 && (
// //                   <div>
// //                     Existem mais {homeFilter.avisosPartnumber.length - 3} itens
// //                     com histórico de alteração de partnumber.
// //                   </div>
// //                 )}
// //               </div>
// //             )}
// //           <h3>{name}</h3>
// //           {/* {breadcrumbs.map((bread, index, array) => {
// //             const label =
// //               array.length - 1 === index ? bread.name : `${bread.name} / `;

// //             return (
// //               <Link
// //                 key={index}
// //                 to={bread.url}
// //                 onClick={() => dispatch(handleHomeFilterClear())}
// //               >
// //                 {label}
// //               </Link>
// //             );
// //           })} */}
// //           {breadcrumbs.map((bread, index, array) => {
// //             const isLast = array.length - 1 === index;
// //             return (
// //               <span key={bread.url || index}>
// //                 {isLast ? (
// //                   <span aria-current="page">{bread.name}</span>
// //                 ) : (
// //                   <Link
// //                     to={bread.url}
// //                     onClick={() => dispatch(handleHomeFilterClear())}
// //                   >
// //                     {bread.name}
// //                   </Link>
// //                 )}
// //                 {!isLast && <span aria-hidden="true"> / </span>}
// //               </span>
// //             );
// //           })}

// //           {/* seta de "voltar" para o penúltimo breadcrumb */}
// //           {/* {breadcrumbs.length > 1 && (
// //             <Link
// //               to={breadcrumbs[breadcrumbs.length - 2].url}
// //               onClick={() => dispatch(handleHomeFilterClear())}
// //               aria-label={`Voltar para ${
// //                 breadcrumbs[breadcrumbs.length - 2].name
// //               }`}
// //               className="breadcrumb-back"
// //             >
// //               ← <span className="sr-only">Voltar</span>
// //             </Link>
// //           )} */}

// //           {breadcrumbs.length > 1 && (
// //             <Link
// //               to={breadcrumbs[breadcrumbs.length - 2].url}
// //               onClick={() => dispatch(handleHomeFilterClear())}
// //               className="breadcrumb-back"
// //               aria-label={`${breadcrumbs[breadcrumbs.length - 2].name}`}
// //               title={`${breadcrumbs[breadcrumbs.length - 2].name}`}
// //               style={{
// //                 marginLeft: '3px',
// //                 display: 'inline-flex',
// //                 alignItems: 'center',
// //                 padding: '2px',
// //                 borderRadius: 999,
// //                 border: '1px solid #2c405a',
// //               }}
// //             >
// //               <MdChevronLeft size={16} color="#2c405a" />
// //             </Link>
// //           )}
// //         </Content.ToolBar.Header>
// //       );
// //     },
// //     [location, dispatch, homeFilter, id]
// //   );

// //   const handleContainer = useCallback(
// //     (data) => {
// //       const { idCatalogo } = data;

// //       /** pega parâmetros da rota */
// //       const paramQuery = new URLSearchParams(location.search);

// //       // console.log(location.search);
// //       // console.log(data);

// //       return paramQuery.has('IDP') ? (
// //         <Page
// //           ref={paginaRef}
// //           id={idCatalogo}
// //           idPagina={Number(paramQuery.get('IDP'))}
// //           zoomInRef={zoomInRef}
// //           zoomOutRef={zoomOutRef}
// //           zoomResetRef={zoomResetRef}
// //         />
// //       ) : (
// //         <Listagem data={data} />
// //         // <>
// //         //   <Listagem data={data} />
// //         //   <SistemaFacesTree data={catalogo} />
// //         // </>
// //       );
// //     },
// //     [location]
// //   );

// //   useEffect(() => {
// //     async function addCart(output, idCatalogo) {
// //       return dispatch(adicionaCarrinhoArrayRequest(idCatalogo, output));
// //     }
// //     async function fetchData() {
// //       try {
// //         const response = await api.get(`app.session/${token}`);
// //         const { data } = response;

// //         const { info, idCatalogo } = data;

// //         const fmtOutputInfo = [];

// //         if (info) {
// //           const fmtInfo = info.split('&');

// //           fmtInfo.forEach((i, index) => {
// //             if (i.includes('IDPAG_')) {
// //               fmtOutputInfo.push({
// //                 idPagina: Number(
// //                   fmtInfo[index].split('=')[1].replaceAll(',', '')
// //                 ),
// //                 idItem: String(
// //                   fmtInfo[index + 1].split('=')[1].replaceAll(',', '')
// //                 ),
// //                 idMaterial: Number(
// //                   fmtInfo[index + 2].split('=')[1].replaceAll(',', '')
// //                 ),
// //                 codimate:
// //                   String(
// //                     fmtInfo[index + 3].split('=')[1].replaceAll(',', '')
// //                   ) !== 'undefined'
// //                     ? String(
// //                         fmtInfo[index + 3].split('=')[1].replaceAll(',', '')
// //                       )
// //                     : null,
// //                 quantidade: Number(
// //                   fmtInfo[index + 4].split('=')[1].replaceAll(',', '')
// //                 ),
// //                 imagemCatalogo: String(
// //                   fmtInfo[index + 5].split('=')[1].replaceAll(',', '')
// //                 ),
// //               });
// //             }
// //           });
// //         }

// //         await addCart(fmtOutputInfo, idCatalogo);

// //         if (info && !sharedManagement) {
// //           dispatch(sharedManagementSet(true));
// //           toast.info('Existem itens no carrinho que foram compartilhados!');
// //           history.push(`/carrinho`);
// //         }
// //       } catch (error) {
// //         toast.error(`Erro ao carregar o compartilhamento ${error}`);
// //       }
// //     }

// //     fetchData();
// //   }, [token, dispatch, sharedManagement]);

// //   const Group = (props) => <components.Group {...props} />;

// //   // console.log(homeFilter);
// //   // console.log(catalogo);

// //   const handleScrollLinkTreeView = () => {
// //     const links = refTtreeView.current.querySelectorAll('a');

// //     links.forEach((elemento) => {
// //       const linkSelecionado = elemento.getAttribute('data-selected');
// //       if (linkSelecionado === 'true') {
// //         setTimeout(() => {
// //           elemento.scrollIntoView({
// //             behavior: 'smooth',
// //             block: 'center',
// //             inline: 'center',
// //           });
// //         }, 1000);
// //       }
// //     });
// //   };

// //   // useEffect(() => {
// //   //   if (dictaphoneEnabled && speechTranscript !== '') {
// //   //     const newValue = speechTranscript.replaceAll('.', '');
// //   //     console.log('Atualizando AsyncSelect com transcript:', newValue);
// //   //     setValueAsyncSelect(newValue);
// //   //     if (formRef.current) {
// //   //       const form = formRef.current.getData();
// //   //       form.idMaterial = newValue;
// //   //       formRef.current.setData(form);
// //   //     }
// //   //     // disparar a busca automaticamente
// //   //     handleFiltroAsyncSelect(newValue);

// //   //     setSpeechTranscript('');
// //   //   }
// //   // }, [dictaphoneEnabled, speechTranscript, id]);

// //   useEffect(() => {
// //     if (dictaphoneEnabled && speechTranscript !== '') {
// //       const newValue = speechTranscript.replaceAll('.', '');
// //       setValueAsyncSelect(newValue);
// //       setSelectedOption({
// //         value: '__typed__',
// //         label: newValue,
// //         __isTyped: true,
// //       });

// //       if (formRef.current) {
// //         const form = formRef.current.getData();
// //         form.idMaterial = newValue;
// //         formRef.current.setData(form);
// //       }

// //       handleFiltroAsyncSelect(newValue);

// //       setSelectedOption({
// //         value: '__typed__',
// //         label: newValue,
// //         __isTyped: true,
// //       });
// //       setValueAsyncSelect('');
// //       setIsEditing(false);

// //       setSpeechTranscript('');
// //     }
// //   }, [dictaphoneEnabled, speechTranscript, id]);

// //   // useEffect(() => {
// //   //   if (formRef.current) {
// //   //     const form = formRef.current.getData();

// //   //     if (form.idMaterial !== valueAsyncSelect) {
// //   //       form.idMaterial = valueAsyncSelect;
// //   //       formRef.current.setData(form);
// //   //     }
// //   //   }
// //   // }, [valueAsyncSelect]);

// //   // adapters para sua API existente:
// //   const fetchOptions = (q) =>
// //     new Promise((resolve) => getMaterial({ id, value: q }, resolve));

// //   const fetchAll = () => fetchOptions(''); // ou crie um endpoint dedicado para "todos"

// //   const paramRoute = new URLSearchParams(location.search);
// //   const hasIDP = paramRoute.has('IDP');

// //   return (
// //     <>
// //       <Container>
// //         {catalogo && (
// //           <>
// //             <Container.Header>
// //               {[opTipoAcao.PLATAFORMA, opTipoAcao.INTEGRACAO_CONSULTA].includes(
// //                 action
// //               ) && (
// //                 <Container.Header.BtnBack
// //                   title="Voltar para a Home"
// //                   onClick={() => {
// //                     dispatch(handleHomeFilterClear());
// //                     history.push('/');
// //                   }}
// //                 >
// //                   <MdHome size={30} />
// //                 </Container.Header.BtnBack>
// //               )}
// //               {/* {empresa.idEmpresa === opEmpresa.DMB && (
// //                 <Container.Header.DownloadPdf
// //                   title="Download catálogo pdf completo"
// //                   href={catalogoPdf}
// //                   target="_blank"
// //                 >
// //                   <MdPictureAsPdf size={30} />
// //                 </Container.Header.DownloadPdf>
// //               )} */}
// //               {exibePdfCatalogoCdi && (
// //                 <Container.Header.DownloadPdf
// //                   as="button"
// //                   type="button"
// //                   title="Abrir PDF completo do catálogo"
// //                   onClick={handleAbrirPdfCatalogo}
// //                 >
// //                   <MdPictureAsPdf size={30} />
// //                 </Container.Header.DownloadPdf>
// //               )}
// //               <WrapperTittleInfoSubtitle>
// //                 <WrapperTitleInfo>
// //                   <Container.Header.Title>
// //                     {catalogo.nome}

// //                     {(catalogo || catalogo.arquivo) && (
// //                       <Info.Root topIcon="0" rightIcon="-5px">
// //                         {nSerie && nSerie.length > 0 && (
// //                           <div>
// //                             <strong>S/N:</strong>
// //                             {nSerie.map((item) => item.numeroSerie).join(',')}
// //                           </div>
// //                         )}
// //                         {catalogo.arquivo.fabricante && (
// //                           <div>
// //                             <strong>Fabricante:</strong>
// //                             {catalogo.arquivo.fabricante.descricao}
// //                           </div>
// //                         )}
// //                         {catalogo.arquivo.modelos &&
// //                           catalogo.arquivo.modelos.length > 0 && (
// //                             <div>
// //                               <strong>Modelo:</strong>
// //                               {catalogo.arquivo.modelos
// //                                 .map((item) => item.descricao)
// //                                 .join(',')}
// //                             </div>
// //                           )}
// //                         {catalogo.versao && (
// //                           <div>
// //                             <strong>Versão:</strong>
// //                             {catalogo.versao}
// //                           </div>
// //                         )}
// //                       </Info.Root>
// //                     )}
// //                   </Container.Header.Title>
// //                 </WrapperTitleInfo>
// //                 <WrapperSubtitles>
// //                   <Container.Header.Subtitle>
// //                     {catalogo.arquivo.fabricante.descricao}
// //                   </Container.Header.Subtitle>
// //                   <Container.Header.Subtitle>-</Container.Header.Subtitle>
// //                   <Container.Header.Subtitle>
// //                     {catalogo.arquivo.modelos
// //                       .map((item) => item.descricao)
// //                       .join(' | ')}
// //                   </Container.Header.Subtitle>
// //                 </WrapperSubtitles>
// //               </WrapperTittleInfoSubtitle>

// //               {[opTipoAcao.INTEGRACAO_CATALOGO].includes(action) &&
// //                 [opTipoAcesso.CLIENTE].includes(Number(adm)) &&
// //                 signed && (
// //                   <Container.Header.BtnFavorite title="Solicitar ao fornecedor para manter o acesso ao catálogo">
// //                     <MdStarOutline size={25} />
// //                   </Container.Header.BtnFavorite>
// //                 )}
// //               {/* {exibeIdiomaCatalogo && (
// //                 <div
// //                   style={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     marginRight: 12,
// //                   }}
// //                 >
// //                   <IdiomaCatalogoSelect
// //                     value={idiomaCatalogo}
// //                     onChange={(value) => dispatch(setIdiomaCatalogo(value))}
// //                   />
// //                 </div>
// //               )} */}
// //               <Container.Header.Search>
// //                 <Form.Row>
// //                   <Form ref={formRef}>
// //                     <div
// //                       style={{
// //                         position: 'relative',
// //                       }}
// //                     >
// //                       <Info.Root rightIcon="470px" topIcon="7px">
// //                         <div>
// //                           <span id="grey-italic-span">
// //                             <strong id="white-bold-span">
// //                               Partnumber - Descrição |{' '}
// //                             </strong>
// //                             Sistema <strong id="white-bold-span">| </strong>
// //                             Níveis / ...
// //                           </span>
// //                         </div>
// //                         <div>
// //                           <span id="grey-italic-padding-span">OU</span>
// //                         </div>
// //                         <div>
// //                           <span id="grey-italic-span">
// //                             <strong id="white-bold-span">
// //                               Codigo ERP - Descrição |{' '}
// //                             </strong>
// //                             Sistema <strong id="white-bold-span">| </strong>
// //                             Níveis / ...
// //                           </span>
// //                         </div>
// //                       </Info.Root>
// //                     </div>
// //                     {catalogo.arranjoPagina && (
// //                       <AsyncSelect
// //                         id="idArranjo"
// //                         name="idArranjo"
// //                         placeholder="Digite para pesquisar um arranjo..."
// //                         isClearable
// //                         cacheOptions
// //                         defaultOptions
// //                         loadOptions={(value, cb) =>
// //                           getArranjo({ id, value }, cb)
// //                         }
// //                         onChange={(data) => handleSerieArranjo(data)}
// //                         width={270}
// //                       />
// //                     )}
// //                     {/* <SearchAutocomplete
// //                       fetchOptions={fetchOptions}
// //                       fetchAll={fetchAll}
// //                       onOptionSelected={(option) => {
// //                         // o mesmo que você já faz em handlePagina(option)
// //                         handlePagina(option);
// //                       }}
// //                       onSearchTerm={(term) => {
// //                         // o mesmo que você já faz em handleFiltroAsyncSelect(term)
// //                         handleFiltroAsyncSelect(term);
// //                       }}
// //                       initialQuery={
// //                         new URLSearchParams(location.search).get('q') || ''
// //                       }
// //                     /> */}
// //                     {/* <SearchAutocomplete
// //                       idCatalogo={id}
// //                       getMaterial={getMaterial}
// //                       width={450}
// //                       onOptionSelected={(option) => {
// //                         handlePagina(option);
// //                       }}
// //                       onSearchTerm={(term) => {
// //                         handleFiltroAsyncSelect(term);
// //                       }}
// //                       initialQuery={
// //                         new URLSearchParams(location.search).get('q') || ''
// //                       }
// //                     /> */}
// //                     <SearchAutocomplete
// //                       idCatalogo={id}
// //                       getMaterial={getMaterial}
// //                       width={450}
// //                       onOptionSelected={(option) => {
// //                         const label = option?.label || {};

// //                         if (label.partnumberPesquisadoEstaDesatualizado) {
// //                           toast.info(
// //                             `O partnumber ${label.partnumberPesquisado} foi encontrado no histórico, mas o atual agora é ${label.partnumberAtual}.`
// //                           );
// //                         }

// //                         handlePagina(option);
// //                       }}
// //                       onSearchTerm={(term) => {
// //                         handleFiltroAsyncSelect(term);
// //                       }}
// //                       initialQuery={
// //                         new URLSearchParams(location.search).get('q') || ''
// //                       }
// //                     />
// //                   </Form>
// //                   {/* {dictaphoneEnabled && (
// //                     <Dictaphone onTranscriptChange={setSpeechTranscript} />
// //                   )} */}
// //                   {/* <BtnFilter
// //                     title="Filtrar páginas pelo termo digitado"
// //                     onClick={() => {
// //                       // handleFiltroAsyncSelect(valueAsyncSelect);
// //                       // setSpeechTranscript('');
// //                       const termo = formRef.current.getFieldValue('idMaterial');
// //                       console.log(
// //                         'BUTTON -> handleFiltroAsyncSelect disparada com termo:',
// //                         termo
// //                       );
// //                       console.log(
// //                         'BUTTON -> handleFiltroAsyncSelect disparada com valueAsyncSelect:',
// //                         valueAsyncSelect
// //                       );
// //                       handleFiltroAsyncSelect(termo);
// //                       setSpeechTranscript('');
// //                       // setValueAsyncSelect(null);
// //                     }}
// //                   >
// //                     <MdSearch size={20} />
// //                   </BtnFilter> */}
// //                   {/* <BtnFilter
// //                     title="Filtrar páginas pelo termo digitado"
// //                     // onClick={() => {
// //                     //   handleFiltroAsyncSelect(valueAsyncSelect);
// //                     //   setSpeechTranscript('');
// //                     // }}
// //                     onClick={() => {
// //                       const termo = (valueAsyncSelect || '').trim();
// //                       if (!termo) return;

// //                       handleFiltroAsyncSelect(termo);

// //                       // <<< mantém o termo visível no AsyncSelect >>>
// //                       setSelectedOption({
// //                         value: '__typed__',
// //                         label: termo,
// //                         __isTyped: true,
// //                       });
// //                       setValueAsyncSelect('');
// //                       setIsEditing(false);

// //                       setSpeechTranscript('');
// //                     }}
// //                   >
// //                     <MdSearch size={20} />
// //                   </BtnFilter> */}
// //                 </Form.Row>
// //               </Container.Header.Search>
// //               {exibeIdiomaCatalogo && (
// //                 <div
// //                   style={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     margin: 8,
// //                   }}
// //                 >
// //                   <IdiomaCatalogoSelect
// //                     value={idiomaCatalogo}
// //                     onChange={(value) => dispatch(setIdiomaCatalogo(value))}
// //                   />
// //                 </div>
// //               )}
// //             </Container.Header>

// //             <Wrapper>
// //               {!pageMaximize && (
// //                 <>
// //                   <Menu>
// //                     {catalogo && (
// //                       <>
// //                         <Menu.Content hidden={menuHidden}>
// //                           <Menu.Content.TreeView>
// //                             <Menu.Content.Filter>
// //                               {catalogo.sistema && (
// //                                 <span>
// //                                   {catalogo.sistema.descricao}
// //                                   <button
// //                                     type="button"
// //                                     onClick={() =>
// //                                       handleFiltro(
// //                                         'FLT_IDS',
// //                                         catalogo.sistema.codiSist
// //                                       )
// //                                     }
// //                                   >
// //                                     <MdClose size={12} />
// //                                   </button>
// //                                 </span>
// //                               )}

// //                               {catalogo.local && (
// //                                 <span>
// //                                   {catalogo.local.descricao}
// //                                   <button
// //                                     type="button"
// //                                     onClick={() =>
// //                                       handleFiltro(
// //                                         'FLT_IDL',
// //                                         catalogo.local.codiLoca
// //                                       )
// //                                     }
// //                                   >
// //                                     <MdClose size={12} />
// //                                   </button>
// //                                 </span>
// //                               )}
// //                             </Menu.Content.Filter>
// //                             <TreeView data={catalogo} ref={refTtreeView} />
// //                             {/* {utilizaVisualizaoFacesSistema() && hasIDP && (
// //                             <SistemaFacesTree data={catalogo} />
// //                           )} */}
// //                           </Menu.Content.TreeView>

// //                           {/* <Menu.Content.TreeView>
// //                           {
// //                             // utilizaVisualizaoFacesSistema() &&
// //                             hasIDP && <SistemaFacesTree data={catalogo} />
// //                           }
// //                         </Menu.Content.TreeView> */}

// //                           {/* <Menu.Content.File>
// //                           <h4>Anexos</h4>
// //                           <ul>
// //                             <li>
// //                               <a href="/#">NomeDaPeça.mp4</a>
// //                             </li>
// //                             <li>
// //                               <a href="/#">ManualDaPeça.pdf</a>
// //                             </li>
// //                             <li>
// //                               <a href="/#">DiagramaSecundario.pdf</a>
// //                             </li>
// //                           </ul>
// //                         </Menu.Content.File> */}
// //                         </Menu.Content>
// //                         {/* <SistemaFacesTree data={catalogo} /> */}
// //                         <Menu.BtnCollapse
// //                           collapse={menuHidden}
// //                           onClick={() => setMenuHidden(!menuHidden)}
// //                         >
// //                           {menuHidden ? (
// //                             <MdChevronRight size={16} />
// //                           ) : (
// //                             <MdChevronLeft size={16} />
// //                           )}
// //                         </Menu.BtnCollapse>
// //                       </>
// //                     )}
// //                   </Menu>
// //                   {utilizaVisualizaoFacesSistema() && hasIDP && (
// //                     <Menu>
// //                       <Menu.Content hidden={menuFacesHidden}>
// //                         <Menu.Content.TreeView>
// //                           {
// //                             // utilizaVisualizaoFacesSistema() &&
// //                             hasIDP && <SistemaFacesTree data={catalogo} />
// //                           }
// //                         </Menu.Content.TreeView>
// //                       </Menu.Content>
// //                       <Menu.BtnCollapse
// //                         collapse={menuFacesHidden}
// //                         onClick={() => setMenuFacesHidden(!menuFacesHidden)}
// //                       >
// //                         {menuHidden ? (
// //                           <MdChevronRight size={16} />
// //                         ) : (
// //                           <MdChevronLeft size={16} />
// //                         )}
// //                       </Menu.BtnCollapse>
// //                     </Menu>
// //                   )}
// //                 </>
// //               )}

// //               <Content>
// //                 <Content.ToolBar>
// //                   {catalogo && handleBreadcrumb(catalogo)}

// //                   {controle && (
// //                     <Content.ToolBar.DrawControl>
// //                       <button
// //                         type="button"
// //                         onClick={debounce(() => {
// //                           handlePageNav(-1);
// //                           handleScrollLinkTreeView();
// //                         }, 100)}
// //                       >
// //                         <MdChevronLeft size={20} />
// //                       </button>
// //                       <span>{shownPage}</span>
// //                       <button
// //                         type="button"
// //                         onClick={debounce(() => {
// //                           handlePageNav(1);
// //                           handleScrollLinkTreeView();
// //                         }, 100)}
// //                       >
// //                         <MdChevronRight size={20} />
// //                       </button>
// //                       <button ref={zoomInRef} type="button">
// //                         <MdZoomIn size={20} />
// //                       </button>
// //                       <button ref={zoomOutRef} type="button">
// //                         <MdZoomOut size={20} />
// //                       </button>
// //                       <button ref={zoomResetRef} type="button">
// //                         <MdYoutubeSearchedFor size={20} />
// //                       </button>
// //                       <button type="button" onClick={handleRedimensionar}>
// //                         {pageMaximize ? (
// //                           <MdFullscreenExit size={20} color="#ff6d3c" />
// //                         ) : (
// //                           <MdFullscreen size={20} />
// //                         )}
// //                       </button>
// //                       {/* <button type="button" onClick={handleImprimir}>
// //                         <MdPrint size={20} />
// //                       </button> */}
// //                       <button
// //                         type="button"
// //                         onClick={handlePDF}
// //                         disabled={loadingButtonPrint}
// //                       >
// //                         {loadingButtonPrint ? (
// //                           <GiSandsOfTime size={20} color="#ff6d3c" />
// //                         ) : (
// //                           <MdPrint size={20} />
// //                         )}
// //                       </button>
// //                       <button
// //                         type="button"
// //                         onClick={handleMail}
// //                         disabled={loadingButtonMail}
// //                       >
// //                         {loadingButtonMail ? (
// //                           <GiSandsOfTime size={20} color="#ff6d3c" />
// //                         ) : (
// //                           <MdEmail size={20} />
// //                         )}
// //                       </button>
// //                     </Content.ToolBar.DrawControl>
// //                   )}
// //                 </Content.ToolBar>

// //                 {catalogo && handleContainer(catalogo)}
// //               </Content>
// //             </Wrapper>
// //           </>
// //         )}
// //       </Container>
// //     </>
// //   );
// // }

// // export default Classificacao;

// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { Link, useParams, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   MdSearch,
//   MdYoutubeSearchedFor,
//   MdZoomIn,
//   MdZoomOut,
//   MdFullscreen,
//   MdFullscreenExit,
//   MdPrint,
//   MdChevronLeft,
//   MdChevronRight,
//   MdClose,
//   MdEmail,
//   MdHome,
//   // MdStar,
//   MdStarOutline,
//   MdPictureAsPdf,
//   MdAccountTree,
//   MdLayers,
// } from 'react-icons/md';

// import { GiSandsOfTime } from 'react-icons/gi';

// import { components } from 'react-select';

// // import { border, borderRadius } from 'polished';
// // import { borderRadius, padding } from 'polished';
// import { toast } from 'react-toastify';
// import api from '../../../services/api';
// import history from '../../../services/history';

// import { AppError } from '../../../errors/AppError';

// import {
//   opEmpresa,
//   // opSimNao,
//   opTipoAcao,
//   opTipoAcesso,
// } from '../../../lib/const';
// import { debounce } from '../../../lib/inputUtils';
// import { initialParams } from '../../../lib/reactRouter';
// import { getMaterial, getArranjo } from '../../../lib/asyncUtils';

// import TreeView from '../../../components/TreeView';

// import { Form } from '../../../components/Form';
// import AsyncSelect from '../../../components/Form/Input/AsyncSelect';
// import { Info } from '../../../components/Info';

// import Listagem from './Listagem';
// import Page from './Pagina';

// import {
//   Container,
//   Wrapper,
//   Menu,
//   Content,
//   WrapperTitleInfo,
//   WrapperSubtitles,
//   WrapperTittleInfoSubtitle,
//   BtnFilter,
// } from './styles';
// import {
//   handleHomeFilter,
//   handleHomeFilterClear,
// } from '../../../store/modules/homeFilter/actions';
// import HoverImagePortal from '../../../components/HoverImagePortal';
// import {
//   adicionaCarrinhoArrayRequest,
//   sharedManagementSet,
// } from '../../../store/modules/cart/actions';
// import Dictaphone from '../../../components/SpeechRecognition';
// import {
//   useDictaphone,
//   utilizaVisualizaoFacesSistema,
//   usaIdiomaCatalogo,
//   usaPdfCatalogoCdi,
// } from '../../../lib/paramUtils';
// import { setIdiomaCatalogo } from '../../../store/modules/param/actions';
// import IdiomaCatalogoSelect from '../../../components/IdiomaCatalogoSelect';
// import SearchAutocomplete from '../../../components/Form/Input/SearchAutocomplete';
// import SistemaFacesTree from '../../../components/SistemaFacesTree';
// import {
//   opIdiomaCatalogo,
//   SYSTEM_FACES,
//   SYSTEM_TREE,
// } from '../../../lib/idiomaAppOptions';

// function Classificacao() {
//   const { id } = useParams();
//   const location = useLocation();

//   const dictaphoneEnabled = useDictaphone();

//   const { app, action, signed, token } = useSelector(
//     (state) => state.auth || {}
//   );
//   const { adm, empresa } = useSelector((state) => state.user.profile || {});
//   const { homeFilter } = useSelector((state) => state || {});
//   const { sharedManagement } = useSelector((state) => state.cart || {});

//   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );
//   const exibeIdiomaCatalogo = usaIdiomaCatalogo();
//   const exibePdfCatalogoCdi = usaPdfCatalogoCdi();

//   /** params de idioma para as chamadas (vazio quando não escolhido) */
//   const idiomaParams =
//     idiomaCatalogo !== null ? { idioma: idiomaCatalogo } : {};

//   /** idioma efetivo para os rótulos das colunas laterais */
//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   /** referencia para atribuir controles de zoom */
//   const zoomInRef = useRef();
//   const zoomOutRef = useRef();
//   const zoomResetRef = useRef();

//   const formRef = useRef();
//   const paginaRef = useRef();

//   const refTtreeView = useRef(null);

//   const dispatch = useDispatch();

//   /**
//    * Colunas laterais (árvore de sistemas / faces do sistema) iniciam
//    * FECHADAS: em tablet (1340 x 800) a prioridade é o desenho da peça e a
//    * tabela de itens. Os trilhos laterais permanecem visíveis para abrir e
//    * fechar rapidamente, e os painéis são sobrepostos ao conteúdo.
//    */
//   const [menuHidden, setMenuHidden] = useState(true);
//   const [menuFacesHidden, setMenuFacesHidden] = useState(true);
//   const [pageMaximize, setPageMaximize] = useState(false);

//   const [catalogo, setCatalogo] = useState(null);
//   const [paginaCatalogo, setPaginaCatalogo] = useState([]);
//   const [controle, setControle] = useState(false);
//   const [shownPage, setShownPage] = useState(0);
//   const [nSerie, setNSerie] = useState([]);
//   const [catalogoPdf, setCatalogoPdf] = useState(null);

//   const [loadingButtonPrint, setLoadingButtonPrint] = useState(false);
//   const [loadingButtonMail, setLoadingButtonMail] = useState(false);

//   const [fmtFilterSearch, setFmtFilterSearch] = useState([]);

//   const [valueAsyncSelect, setValueAsyncSelect] = useState('');

//   const [isHovered, setIsHovered] = useState(null);

//   const [speechTranscript, setSpeechTranscript] = useState('');

//   const selectMaterialRef = useRef(null);
//   const [selectedOption, setSelectedOption] = useState(null);
//   // const [valueAsyncSelect, setValueAsyncSelect] = useState('');
//   const [isEditing, setIsEditing] = useState(false);
//   const prevQRef = useRef('');

//   useEffect(() => {
//     const q = new URLSearchParams(location.search).get('q') || '';
//     if (q !== prevQRef.current) {
//       setValueAsyncSelect(q);
//       // Se ainda não existe seleção real, mantém o "valor sintético" para exibir o texto
//       setSelectedOption((curr) => {
//         if (!q) return null;
//         if (!curr || curr.__isTyped) {
//           return { value: '__typed__', label: q, __isTyped: true };
//         }
//         return curr; // mantém a seleção real
//       });
//       prevQRef.current = q;
//     }
//   }, [location.search]);

//   useEffect(() => {
//     api
//       .get(`/catalogo-navegacao/${id}/pagina`, {
//         params: { ...idiomaParams },
//       })
//       .then((response) => {
//         setPaginaCatalogo(response.data);
//       });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id, idiomaCatalogo]);

//   useEffect(() => {
//     if (Array.isArray(homeFilter.paginas) && homeFilter.paginas.length > 0) {
//       setFmtFilterSearch(
//         paginaCatalogo.filter((i) =>
//           homeFilter.paginas.some((j) => i.idPagina === j.idPagina)
//         )
//       );
//     } else {
//       setFmtFilterSearch(paginaCatalogo);
//     }
//   }, [paginaCatalogo, homeFilter]);

//   useEffect(() => {
//     /** pega parâmetros da rota */
//     const paramQuery = new URLSearchParams(location.search);

//     const paramRoute = {
//       ...initialParams,
//       ...Object.fromEntries(paramQuery),
//     };

//     api
//       .get(`/catalogo-navegacao/${id}`, {
//         params: {
//           ...paramRoute,
//           ...idiomaParams,
//         },
//       })
//       .then((response) => {
//         setCatalogo(response.data);

//         /** Preenchimento do campos arranjo */
//         const { arranjo } = response.data;

//         if (arranjo && formRef.current) {
//           const valorAtual = formRef.current.getFieldValue('idArranjo');
//           if (!valorAtual) {
//             formRef.current.setFieldValue('idArranjo', {
//               label: `N/S: ${arranjo.numeroSerie} - ${arranjo.nome}`,
//               value: `${arranjo.idSerie}.${arranjo.idArranjo}`,
//             });
//           }
//         }
//       })
//       .catch((err) => {
//         AppError(err);
//       });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id, location, idiomaCatalogo]);

//   useEffect(() => {
//     api
//       .get(`/catalogo/${id}`)
//       .then((response) => {
//         setCatalogoPdf(response.data.arquivo.url);
//         setNSerie(response.data.series || []);
//       })
//       .catch((err) => {
//         AppError(err);
//       });
//   }, [id]);

//   useEffect(() => {
//     /** pega parâmetros da rota */
//     const paramQuery = new URLSearchParams(location.search);

//     setControle(paramQuery.has('IDP'));
//     if (catalogo && paramQuery.has('IDP')) {
//       const page = Number(paramQuery.get('IDP'));

//       const { paginas = [] } = catalogo;

//       const index = paginas.findIndex((p) => p === page);
//       if (index >= 0) setShownPage(index + 1);

//       if (homeFilter.value !== null) {
//         const indexHomeFilter = fmtFilterSearch.findIndex(
//           (p) => p.idPagina === page
//         );
//         if (indexHomeFilter >= 0) setShownPage(indexHomeFilter + 1);
//       }
//     }
//   }, [location, catalogo, homeFilter, fmtFilterSearch]);

//   // const handleFiltroAsyncSelect = useCallback(
//   //   (value) => {
//   //     api
//   //       .get(`/catalogo-filtro/${id}/material-catalogo`, {
//   //         params: {
//   //           q: value,
//   //         },
//   //       })
//   //       .then((response) => {
//   //         const { searchHandle, paginas, paginasERP } = response.data;

//   //         // console.log(value);

//   //         dispatch(handleHomeFilter(value, searchHandle, paginas, paginasERP));
//   //       })
//   //       .catch((error) => {
//   //         console.error('Erro ao filtrar:', error);
//   //       })
//   //       .finally(() => {
//   //         // setValueAsyncSelect(null);
//   //         // setValueAsyncSelect('');
//   //         // history.push(`/catalogo.partes/${id}`);
//   //         history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);
//   //       });

//   //     // history.push(`/catalogo.partes/${id}`);
//   //   },
//   //   [id, dispatch]
//   // );

//   // const handleFiltroAsyncSelect = useCallback(
//   //   (value) => {
//   //     api
//   //       .get(`/catalogo-filtro/${id}/material-catalogo`, {
//   //         params: { q: value },
//   //       })
//   //       .then((response) => {
//   //         const { searchHandle, paginas, paginasERP } = response.data;
//   //         dispatch(handleHomeFilter(value, searchHandle, paginas, paginasERP));
//   //       })
//   //       .catch((error) => console.error('Erro ao filtrar:', error))
//   //       .finally(() => {
//   //         history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);
//   //         setTimeout(() => {
//   //           try {
//   //             const el = selectMaterialRef.current;
//   //             if (el && typeof el.focus === 'function') {
//   //               el.focus();
//   //             }
//   //           } catch (err) {
//   //             console.error('Erro ao devolver foco:', err);
//   //           }
//   //         }, 0);
//   //       });
//   //   },
//   //   [id, dispatch]
//   // );

//   const handleFiltroAsyncSelect = useCallback(
//     (value) => {
//       api
//         .get(`/catalogo-filtro/${id}/material-catalogo`, {
//           params: { q: value, ...idiomaParams },
//         })
//         .then((response) => {
//           const {
//             searchHandle,
//             paginas,
//             paginasERP,
//             avisosPartnumber = [],
//           } = response.data;

//           dispatch(
//             handleHomeFilter(
//               value,
//               searchHandle,
//               paginas,
//               paginasERP,
//               avisosPartnumber
//             )
//           );

//           if (avisosPartnumber.length === 1) {
//             const aviso = avisosPartnumber[0];

//             toast.info(
//               `O partnumber ${aviso.partnumberPesquisado} foi encontrado no histórico, mas o atual agora é ${aviso.partnumberAtual}.`
//             );
//           }

//           if (avisosPartnumber.length > 1) {
//             toast.info(
//               `${avisosPartnumber.length} itens encontrados possuem partnumber atualizado. Veja os avisos na tela.`
//             );
//           }
//         })
//         .catch((error) => console.error('Erro ao filtrar:', error))
//         .finally(() => {
//           history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);

//           setTimeout(() => {
//             try {
//               const el = selectMaterialRef.current;
//               if (el && typeof el.focus === 'function') {
//                 el.focus();
//               }
//             } catch (err) {
//               console.error('Erro ao devolver foco:', err);
//             }
//           }, 0);
//         });
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [id, dispatch, idiomaCatalogo]
//   );

//   const handleAbrirPdfCatalogo = useCallback(() => {
//     api
//       .get(`/pdf-catalogo/${id}`)
//       .then((response) => {
//         const { existe, url, mensagem } = response.data || {};

//         if (existe && url) {
//           window.open(url, '_blank');
//         } else {
//           toast.warn(mensagem || 'O catálogo não foi gerado.');
//         }
//       })
//       .catch(() => {
//         toast.error('Não foi possível verificar o PDF do catálogo.');
//       });
//   }, [id]);

//   // const handleFiltroPaginas = useCallback(() => {
//   //   // const { value, searchHandle, paginas, paginasERP } = homeFilter;

//   //   // console.log(value, searchHandle, paginas, paginasERP);

//   //   // levar para pagina de busca das páginas com o value pesquisado
//   //   // history.push(`/catalogo.partes/${id}/paginas-filtro`);

//   //   console.log('TESTE');
//   // }, [history, id]);

//   const handlePagina = useCallback(
//     (data) => {
//       // const { value = '' } = data || {};
//       const { value = '', label = {} } = data || {};
//       const [, idPagina] = value.split('.');

//       if (idPagina) {
//         const { niveis = [] } =
//           paginaCatalogo.find((p) => p.idPagina === Number(idPagina)) || {};

//         const searchLocation = [];

//         /** processa os níveis da página */
//         // niveis.forEach((itemNivel) => {
//         //   searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
//         // });

//         /** mantém os filtros já aplicados antes de abrir a página do item */
//         const paramQuery = new URLSearchParams(location.search);
//         ['FLT_IDS', 'FLT_IDL', 'FLT_IDE', 'FLT_IDA'].forEach((key) => {
//           const paramValue = paramQuery.get(key);
//           if (paramValue) searchLocation.push(`${key}=${paramValue}`);
//         });

//         /**
//          * Usa a hierarquia retornada pela própria busca quando disponível.
//          * Isso evita abrir a página com IDN incompleto/incorreto e mantém
//          * a árvore de Faces do Sistema limitada ao sistema da página clicada.
//          */
//         if (label.paginaNivelURL) {
//           searchLocation.push(label.paginaNivelURL);
//         } else {
//           niveis.forEach((itemNivel) => {
//             searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
//           });
//         }

//         /** processa página */
//         searchLocation.push(`IDP=${idPagina}`);
//         /** processa item */
//         // searchLocation.push(`IDI=${data.value}`);
//         searchLocation.push(`IDI=${value}`);

//         /** Adiciona materila ERP URL para ser filtrado e selecionado no ItemCart */
//         // if (data.label.codimate) {
//         //   searchLocation.push(`ERP=${data.label.codimate}`);
//         // }

//         /** Adiciona material ERP na URL para ser selecionado no ItemCart */
//         if (label.codimate) {
//           searchLocation.push(`ERP=${label.codimate}`);
//         }

//         history.push(`${id}?${searchLocation.join('&')}`);

//         // devolve o foco para continuar exibindo o texto digitado
//         setTimeout(() => {
//           try {
//             const el = selectMaterialRef.current;
//             if (el && typeof el.focus === 'function') el.focus();
//           } catch (err) {
//             console.error('Erro ao devolver foco:', err);
//           }
//         }, 0);
//       }
//     },
//     // [id, paginaCatalogo]
//     [id, paginaCatalogo, location.search]
//   );

//   const handleSerieArranjo = useCallback(
//     (data) => {
//       const params = [];

//       /** separa valores "serie.arranjo" */
//       const { value = '' } = data || {};
//       const [serie, arranjo] = value.split('.');

//       /** pega parâmetros da rota */
//       const paramQuery = new URLSearchParams(location.search);
//       const paramRoute = {
//         ...initialParams,
//         ...Object.fromEntries(paramQuery),
//       };

//       /** processa os parâmetros de sistema e local caso eles existam no primeiro ciclo */
//       const { FLT_IDS: fltIdS, FLT_IDL: fltIdL } = paramRoute;
//       if (fltIdS) params.push(`FLT_IDS=${fltIdS}`);
//       if (fltIdL) params.push(`FLT_IDL=${fltIdL}`);

//       /** processa arranjo */
//       if (serie && arranjo) {
//         params.push(`FLT_IDE=${serie}`);
//         params.push(`FLT_IDA=${arranjo}`);
//       }

//       /** monta rota para redirecionamento */
//       const routeParam = `?${params.join('&')}`;

//       if (location.search !== routeParam)
//         history.push(location.pathname + routeParam);
//     },
//     [location]
//   );

//   // const handlePageNavFilter = useCallback((step) => {
//   //   if (homeFilter.value !== null) {
//   //     const currentPage = paginaCatalogo[shownPage - 1];

//   //     console.log(currentPage);

//   //     const indexCurrentPage = fmtFilterSearch.indexOf(
//   //       fmtFilterSearch.find((i) => i.idPagina === currentPage.idPagina)
//   //     );

//   //     console.log('indexCurrentPage...', indexCurrentPage);
//   //     console.log(
//   //       'fmtFilterSearch[indexCurrentPage + step]...',
//   //       fmtFilterSearch[indexCurrentPage + step]
//   //     );

//   //     if (fmtFilterSearch[indexCurrentPage + step] === undefined) return;

//   //     const { idPagina, niveis } = fmtFilterSearch[indexCurrentPage + step];
//   //     const { idCatalogo } = catalogo;

//   //     const searchLocation = [];

//   //     niveis.forEach((itemNivel) => {
//   //       searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
//   //     });

//   //     searchLocation.push(`IDP=${idPagina}`);

//   //     history.push(`${idCatalogo}?${searchLocation.join('&')}`);
//   //   }
//   // }, []);

//   const handlePageNav = useCallback(
//     (step) => {
//       if (catalogo && step !== 0) {
//         const nextPage = shownPage - 1 + step;

//         // console.log('\n paginaCatalogo...', paginaCatalogo);
//         // console.log('homeFilter...', homeFilter);
//         // console.log('fmtFilterSearch...', fmtFilterSearch);

//         // console.log('shownPage, step...', shownPage, step);
//         // console.log(
//         //   'nextPage, fmtFilterSearch.length...',
//         //   nextPage,
//         //   fmtFilterSearch.length
//         // );

//         if (homeFilter.value !== null) {
//           const currentPage = fmtFilterSearch[shownPage - 1];

//           // console.log(currentPage);

//           const indexCurrentPage = fmtFilterSearch.indexOf(
//             fmtFilterSearch.find((i) => i.idPagina === currentPage.idPagina)
//           );

//           // console.log('indexCurrentPage...', indexCurrentPage);
//           // console.log(
//           //   'fmtFilterSearch[indexCurrentPage + step]...',
//           //   fmtFilterSearch[indexCurrentPage + step]
//           // );

//           if (fmtFilterSearch[indexCurrentPage + step] === undefined) return;

//           const { idPagina, niveis } = fmtFilterSearch[indexCurrentPage + step];
//           const { idCatalogo } = catalogo;

//           const searchLocation = [];

//           niveis.forEach((itemNivel) => {
//             searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
//           });

//           searchLocation.push(`IDP=${idPagina}`);

//           history.push(`${idCatalogo}?${searchLocation.join('&')}`);
//         }

//         /** Navega para a página encontrada */
//         if (
//           homeFilter.value === null &&
//           nextPage >= 0 &&
//           nextPage < paginaCatalogo.length
//         ) {
//           const { idPagina, niveis } = paginaCatalogo[nextPage];

//           const { idCatalogo, paginas = [] } = catalogo;

//           /** verifica se a página não está filtrada */
//           if (paginas.find((p) => p === idPagina)) {
//             const searchLocation = [];

//             /** pega parâmetros da rota */
//             const paramQuery = new URLSearchParams(location.search);
//             const paramRoute = {
//               ...initialParams,
//               ...Object.fromEntries(paramQuery),
//             };

//             /** processa os parâmetros de sistema, local e pesquisa caso eles existam no primeiro ciclo */
//             const {
//               FLT_IDS: fltIdS,
//               FLT_IDL: fltIdL,
//               FLT_IDE: fltIdE,
//               FLT_IDA: fltIdA,
//               q: fltSearch,
//             } = paramRoute;
//             if (fltIdS) searchLocation.push(`FLT_IDS=${fltIdS}`);
//             if (fltIdL) searchLocation.push(`FLT_IDL=${fltIdL}`);
//             if (fltIdE) searchLocation.push(`FLT_IDE=${fltIdE}`);
//             if (fltIdA) searchLocation.push(`FLT_IDA=${fltIdA}`);
//             if (fltSearch) searchLocation.push(`q=${fltSearch}`);

//             /** processa os níveis da página */
//             niveis.forEach((itemNivel) => {
//               searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
//             });

//             /** processa página */
//             searchLocation.push(`IDP=${idPagina}`);

//             /** monta rota para redirecionamento */
//             history.push(`${idCatalogo}?${searchLocation.join('&')}`);
//           }
//         }
//       }
//     },
//     [location, catalogo, paginaCatalogo, shownPage, fmtFilterSearch, homeFilter]
//   );

//   // const handleImprimir = useCallback(() => {
//   //   /** chama função de impressão do componente filho */
//   //   if (paginaRef.current) {
//   //     paginaRef.current.handleImprimirPagina();
//   //   }
//   // }, []);

//   const handlePDF = useCallback(async () => {
//     setLoadingButtonPrint(true);
//     /** chama função de impressão do componente filho */
//     if (paginaRef.current) {
//       paginaRef.current.handleImprimirPagina(false, setLoadingButtonPrint);
//     }
//   }, []);

//   const handleMail = useCallback(() => {
//     setLoadingButtonMail(true);
//     /** chama função de impressão do componente filho */
//     if (paginaRef.current) {
//       paginaRef.current.handleImprimirPagina(true, setLoadingButtonMail);
//     }
//   }, []);

//   const handleRedimensionar = useCallback(() => {
//     setPageMaximize((state) => !state);

//     /** chama função de redimensionamento do componente filho */
//     if (paginaRef.current) {
//       paginaRef.current.handleRedimensionarPagina(!pageMaximize);
//     }
//   }, [pageMaximize]);

//   const handleFiltro = useCallback(
//     (key) => {
//       dispatch(handleHomeFilterClear());
//       /** pega parâmetros da rota */
//       const paramQuery = new URLSearchParams(location.search);

//       const params = [];
//       paramQuery.forEach((param, index) => {
//         if (index !== key) {
//           params.push(`${index}=${param}`);
//         }
//       });

//       const routeParam = `?${params.join('&')}`;

//       history.push(location.pathname + routeParam);
//     },
//     [location, dispatch]
//   );

//   const handleBreadcrumb = useCallback(
//     (data) => {
//       const breadcrumbs = [];
//       const url = [];

//       /** pega parâmetros da rota */
//       const paramQuery = new URLSearchParams(location.search);
//       const paramRoute = {
//         ...initialParams,
//         ...Object.fromEntries(paramQuery),
//       };

//       /** processa os parâmetros de sistema, local e pesquisa caso eles existam */
//       const {
//         FLT_IDS: fltIdS,
//         FLT_IDL: fltIdL,
//         FLT_IDE: fltIdE,
//         FLT_IDA: fltIdA,
//         q: fltSearch,
//       } = paramRoute;
//       if (fltIdS) url.push(`FLT_IDS=${fltIdS}`);
//       if (fltIdL) url.push(`FLT_IDL=${fltIdL}`);
//       if (fltIdE) url.push(`FLT_IDE=${fltIdE}`);
//       if (fltIdA) url.push(`FLT_IDA=${fltIdA}`);
//       if (fltSearch) url.push(`q=${fltSearch}`);

//       const { idCatalogo, nome, treeView } = data;

//       breadcrumbs.push({
//         name: nome,
//         url:
//           url.length > 0 ? `${idCatalogo}?${url.join('&')}` : `${idCatalogo}`,
//       });

//       let currNode = treeView;

//       Object.keys(paramRoute).forEach((paramAtual) => {
//         /** monta breadcrumb */
//         if (paramAtual.startsWith('IDN_') || paramAtual.startsWith('IDP')) {
//           const [, key] = paramAtual.split('_');

//           /** monta url para acesso */
//           url.push(`${paramAtual}=${paramRoute[paramAtual]}`);

//           const itemNode = currNode.find(
//             (n) =>
//               n.codigo === (Number(key) || idCatalogo) &&
//               n.id === Number(paramRoute[paramAtual])
//           );

//           if (itemNode) {
//             const { descricao } = itemNode;

//             breadcrumbs.push({
//               name: descricao,
//               url: `?${url.join('&')}`,
//             });

//             /** atualiza item da treeview */
//             if (itemNode.itens) currNode = itemNode.itens;
//           }
//         }
//       });

//       const { name = '' } = breadcrumbs[breadcrumbs.length - 1] || {};

//       return (
//         <Content.ToolBar.Header>
//           {homeFilter.value && (
//             <div>
//               <h5>Filtrado por: </h5>
//               <span>{homeFilter.value}</span>
//               <button
//                 type="button"
//                 title="Limpar filtro"
//                 onClick={() => {
//                   dispatch(handleHomeFilterClear());
//                   history.push(`/catalogo.partes/${id}`);
//                 }}
//               >
//                 <MdClose size={20} />
//               </button>
//             </div>
//           )}
//           {Array.isArray(homeFilter.avisosPartnumber) &&
//             homeFilter.avisosPartnumber.length > 0 && (
//               <div
//                 style={{
//                   marginTop: 8,
//                   marginBottom: 8,
//                   padding: '10px 12px',
//                   border: '1px solid #f59e0b',
//                   borderRadius: 8,
//                   background: '#fffbeb',
//                   color: '#92400e',
//                   fontSize: 13,
//                   lineHeight: 1.4,
//                 }}
//               >
//                 <strong>Partnumber atualizado:</strong>

//                 {homeFilter.avisosPartnumber.slice(0, 3).map((aviso) => (
//                   <div
//                     key={`${aviso.idMaterial}-${aviso.idPagina}-${aviso.idItem}`}
//                   >
//                     O partnumber pesquisado{' '}
//                     <strong>{aviso.partnumberPesquisado}</strong> pertence ao
//                     histórico deste item, mas o partnumber atual agora é{' '}
//                     <strong>{aviso.partnumberAtual}</strong>.
//                   </div>
//                 ))}

//                 {homeFilter.avisosPartnumber.length > 3 && (
//                   <div>
//                     Existem mais {homeFilter.avisosPartnumber.length - 3} itens
//                     com histórico de alteração de partnumber.
//                   </div>
//                 )}
//               </div>
//             )}
//           <h3>{name}</h3>
//           {/* {breadcrumbs.map((bread, index, array) => {
//             const label =
//               array.length - 1 === index ? bread.name : `${bread.name} / `;

//             return (
//               <Link
//                 key={index}
//                 to={bread.url}
//                 onClick={() => dispatch(handleHomeFilterClear())}
//               >
//                 {label}
//               </Link>
//             );
//           })} */}
//           {breadcrumbs.map((bread, index, array) => {
//             const isLast = array.length - 1 === index;
//             return (
//               <span key={bread.url || index}>
//                 {isLast ? (
//                   <span aria-current="page">{bread.name}</span>
//                 ) : (
//                   <Link
//                     to={bread.url}
//                     onClick={() => dispatch(handleHomeFilterClear())}
//                   >
//                     {bread.name}
//                   </Link>
//                 )}
//                 {!isLast && <span aria-hidden="true"> / </span>}
//               </span>
//             );
//           })}

//           {/* seta de "voltar" para o penúltimo breadcrumb */}
//           {/* {breadcrumbs.length > 1 && (
//             <Link
//               to={breadcrumbs[breadcrumbs.length - 2].url}
//               onClick={() => dispatch(handleHomeFilterClear())}
//               aria-label={`Voltar para ${
//                 breadcrumbs[breadcrumbs.length - 2].name
//               }`}
//               className="breadcrumb-back"
//             >
//               ← <span className="sr-only">Voltar</span>
//             </Link>
//           )} */}

//           {breadcrumbs.length > 1 && (
//             <Link
//               to={breadcrumbs[breadcrumbs.length - 2].url}
//               onClick={() => dispatch(handleHomeFilterClear())}
//               className="breadcrumb-back"
//               aria-label={`${breadcrumbs[breadcrumbs.length - 2].name}`}
//               title={`${breadcrumbs[breadcrumbs.length - 2].name}`}
//               style={{
//                 marginLeft: '3px',
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 padding: '2px',
//                 borderRadius: 999,
//                 border: '1px solid #2c405a',
//               }}
//             >
//               <MdChevronLeft size={16} color="#2c405a" />
//             </Link>
//           )}
//         </Content.ToolBar.Header>
//       );
//     },
//     [location, dispatch, homeFilter, id]
//   );

//   const handleContainer = useCallback(
//     (data) => {
//       const { idCatalogo } = data;

//       /** pega parâmetros da rota */
//       const paramQuery = new URLSearchParams(location.search);

//       // console.log(location.search);
//       // console.log(data);

//       return paramQuery.has('IDP') ? (
//         <Page
//           ref={paginaRef}
//           id={idCatalogo}
//           idPagina={Number(paramQuery.get('IDP'))}
//           zoomInRef={zoomInRef}
//           zoomOutRef={zoomOutRef}
//           zoomResetRef={zoomResetRef}
//         />
//       ) : (
//         <Listagem data={data} />
//         // <>
//         //   <Listagem data={data} />
//         //   <SistemaFacesTree data={catalogo} />
//         // </>
//       );
//     },
//     [location]
//   );

//   useEffect(() => {
//     async function addCart(output, idCatalogo) {
//       return dispatch(adicionaCarrinhoArrayRequest(idCatalogo, output));
//     }
//     async function fetchData() {
//       try {
//         const response = await api.get(`app.session/${token}`);
//         const { data } = response;

//         const { info, idCatalogo } = data;

//         const fmtOutputInfo = [];

//         if (info) {
//           const fmtInfo = info.split('&');

//           fmtInfo.forEach((i, index) => {
//             if (i.includes('IDPAG_')) {
//               fmtOutputInfo.push({
//                 idPagina: Number(
//                   fmtInfo[index].split('=')[1].replaceAll(',', '')
//                 ),
//                 idItem: String(
//                   fmtInfo[index + 1].split('=')[1].replaceAll(',', '')
//                 ),
//                 idMaterial: Number(
//                   fmtInfo[index + 2].split('=')[1].replaceAll(',', '')
//                 ),
//                 codimate:
//                   String(
//                     fmtInfo[index + 3].split('=')[1].replaceAll(',', '')
//                   ) !== 'undefined'
//                     ? String(
//                         fmtInfo[index + 3].split('=')[1].replaceAll(',', '')
//                       )
//                     : null,
//                 quantidade: Number(
//                   fmtInfo[index + 4].split('=')[1].replaceAll(',', '')
//                 ),
//                 imagemCatalogo: String(
//                   fmtInfo[index + 5].split('=')[1].replaceAll(',', '')
//                 ),
//               });
//             }
//           });
//         }

//         await addCart(fmtOutputInfo, idCatalogo);

//         if (info && !sharedManagement) {
//           dispatch(sharedManagementSet(true));
//           toast.info('Existem itens no carrinho que foram compartilhados!');
//           history.push(`/carrinho`);
//         }
//       } catch (error) {
//         toast.error(`Erro ao carregar o compartilhamento ${error}`);
//       }
//     }

//     fetchData();
//   }, [token, dispatch, sharedManagement]);

//   const Group = (props) => <components.Group {...props} />;

//   // console.log(homeFilter);
//   // console.log(catalogo);

//   const handleScrollLinkTreeView = () => {
//     /** o painel pode estar fechado; nesse caso não há o que rolar */
//     if (!refTtreeView.current) return;

//     const links = refTtreeView.current.querySelectorAll('a');

//     links.forEach((elemento) => {
//       const linkSelecionado = elemento.getAttribute('data-selected');
//       if (linkSelecionado === 'true') {
//         setTimeout(() => {
//           elemento.scrollIntoView({
//             behavior: 'smooth',
//             block: 'center',
//             inline: 'center',
//           });
//         }, 1000);
//       }
//     });
//   };

//   /**
//    * Abre/fecha a coluna da árvore de sistemas.
//    * Os painéis são sobrepostos ao conteúdo, portanto apenas um permanece
//    * aberto por vez para não haver disputa de espaço na tela.
//    */
//   const handleToggleMenuSistemas = () => {
//     setMenuHidden((state) => {
//       if (state) setMenuFacesHidden(true);
//       return !state;
//     });
//   };

//   /** Abre/fecha a coluna das faces do sistema. */
//   const handleToggleMenuFaces = () => {
//     setMenuFacesHidden((state) => {
//       if (state) setMenuHidden(true);
//       return !state;
//     });
//   };

//   /**
//    * Como os painéis laterais são sobrepostos ao conteúdo, a tecla Esc os
//    * fecha — atalho esperado para painéis desse tipo.
//    */
//   useEffect(() => {
//     const handleEsc = (event) => {
//       if (event.key !== 'Escape') return;

//       setMenuHidden(true);
//       setMenuFacesHidden(true);
//     };

//     window.addEventListener('keydown', handleEsc);

//     return () => window.removeEventListener('keydown', handleEsc);
//   }, []);

//   // useEffect(() => {
//   //   if (dictaphoneEnabled && speechTranscript !== '') {
//   //     const newValue = speechTranscript.replaceAll('.', '');
//   //     console.log('Atualizando AsyncSelect com transcript:', newValue);
//   //     setValueAsyncSelect(newValue);
//   //     if (formRef.current) {
//   //       const form = formRef.current.getData();
//   //       form.idMaterial = newValue;
//   //       formRef.current.setData(form);
//   //     }
//   //     // disparar a busca automaticamente
//   //     handleFiltroAsyncSelect(newValue);

//   //     setSpeechTranscript('');
//   //   }
//   // }, [dictaphoneEnabled, speechTranscript, id]);

//   useEffect(() => {
//     if (dictaphoneEnabled && speechTranscript !== '') {
//       const newValue = speechTranscript.replaceAll('.', '');
//       setValueAsyncSelect(newValue);
//       setSelectedOption({
//         value: '__typed__',
//         label: newValue,
//         __isTyped: true,
//       });

//       if (formRef.current) {
//         const form = formRef.current.getData();
//         form.idMaterial = newValue;
//         formRef.current.setData(form);
//       }

//       handleFiltroAsyncSelect(newValue);

//       setSelectedOption({
//         value: '__typed__',
//         label: newValue,
//         __isTyped: true,
//       });
//       setValueAsyncSelect('');
//       setIsEditing(false);

//       setSpeechTranscript('');
//     }
//   }, [dictaphoneEnabled, speechTranscript, id]);

//   // useEffect(() => {
//   //   if (formRef.current) {
//   //     const form = formRef.current.getData();

//   //     if (form.idMaterial !== valueAsyncSelect) {
//   //       form.idMaterial = valueAsyncSelect;
//   //       formRef.current.setData(form);
//   //     }
//   //   }
//   // }, [valueAsyncSelect]);

//   // adapters para sua API existente:
//   const fetchOptions = (q) =>
//     new Promise((resolve) => getMaterial({ id, value: q }, resolve));

//   const fetchAll = () => fetchOptions(''); // ou crie um endpoint dedicado para "todos"

//   const paramRoute = new URLSearchParams(location.search);
//   const hasIDP = paramRoute.has('IDP');

//   return (
//     <>
//       <Container>
//         {catalogo && (
//           <>
//             <Container.Header>
//               {[opTipoAcao.PLATAFORMA, opTipoAcao.INTEGRACAO_CONSULTA].includes(
//                 action
//               ) && (
//                 <Container.Header.BtnBack
//                   title="Voltar para a Home"
//                   onClick={() => {
//                     dispatch(handleHomeFilterClear());
//                     history.push('/');
//                   }}
//                 >
//                   <MdHome size={30} />
//                 </Container.Header.BtnBack>
//               )}
//               {/* {empresa.idEmpresa === opEmpresa.DMB && (
//                 <Container.Header.DownloadPdf
//                   title="Download catálogo pdf completo"
//                   href={catalogoPdf}
//                   target="_blank"
//                 >
//                   <MdPictureAsPdf size={30} />
//                 </Container.Header.DownloadPdf>
//               )} */}
//               {exibePdfCatalogoCdi && (
//                 <Container.Header.DownloadPdf
//                   as="button"
//                   type="button"
//                   title="Abrir PDF completo do catálogo"
//                   onClick={handleAbrirPdfCatalogo}
//                 >
//                   <MdPictureAsPdf size={30} />
//                 </Container.Header.DownloadPdf>
//               )}
//               <WrapperTittleInfoSubtitle>
//                 <WrapperTitleInfo>
//                   <Container.Header.Title>
//                     {catalogo.nome}

//                     {(catalogo || catalogo.arquivo) && (
//                       <Info.Root topIcon="0" rightIcon="-5px">
//                         {nSerie && nSerie.length > 0 && (
//                           <div>
//                             <strong>S/N:</strong>
//                             {nSerie.map((item) => item.numeroSerie).join(',')}
//                           </div>
//                         )}
//                         {catalogo.arquivo.fabricante && (
//                           <div>
//                             <strong>Fabricante:</strong>
//                             {catalogo.arquivo.fabricante.descricao}
//                           </div>
//                         )}
//                         {catalogo.arquivo.modelos &&
//                           catalogo.arquivo.modelos.length > 0 && (
//                             <div>
//                               <strong>Modelo:</strong>
//                               {catalogo.arquivo.modelos
//                                 .map((item) => item.descricao)
//                                 .join(',')}
//                             </div>
//                           )}
//                         {catalogo.versao && (
//                           <div>
//                             <strong>Versão:</strong>
//                             {catalogo.versao}
//                           </div>
//                         )}
//                       </Info.Root>
//                     )}
//                   </Container.Header.Title>
//                 </WrapperTitleInfo>
//                 <WrapperSubtitles>
//                   <Container.Header.Subtitle>
//                     {catalogo.arquivo.fabricante.descricao}
//                   </Container.Header.Subtitle>
//                   <Container.Header.Subtitle>-</Container.Header.Subtitle>
//                   <Container.Header.Subtitle>
//                     {catalogo.arquivo.modelos
//                       .map((item) => item.descricao)
//                       .join(' | ')}
//                   </Container.Header.Subtitle>
//                 </WrapperSubtitles>
//               </WrapperTittleInfoSubtitle>

//               {[opTipoAcao.INTEGRACAO_CATALOGO].includes(action) &&
//                 [opTipoAcesso.CLIENTE].includes(Number(adm)) &&
//                 signed && (
//                   <Container.Header.BtnFavorite title="Solicitar ao fornecedor para manter o acesso ao catálogo">
//                     <MdStarOutline size={25} />
//                   </Container.Header.BtnFavorite>
//                 )}
//               {/* {exibeIdiomaCatalogo && (
//                 <div
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     marginRight: 12,
//                   }}
//                 >
//                   <IdiomaCatalogoSelect
//                     value={idiomaCatalogo}
//                     onChange={(value) => dispatch(setIdiomaCatalogo(value))}
//                   />
//                 </div>
//               )} */}
//               <Container.Header.Search>
//                 <Form.Row>
//                   <Form ref={formRef}>
//                     <div
//                       style={{
//                         position: 'relative',
//                       }}
//                     >
//                       <Info.Root rightIcon="470px" topIcon="7px">
//                         <div>
//                           <span id="grey-italic-span">
//                             <strong id="white-bold-span">
//                               Partnumber - Descrição |{' '}
//                             </strong>
//                             Sistema <strong id="white-bold-span">| </strong>
//                             Níveis / ...
//                           </span>
//                         </div>
//                         <div>
//                           <span id="grey-italic-padding-span">OU</span>
//                         </div>
//                         <div>
//                           <span id="grey-italic-span">
//                             <strong id="white-bold-span">
//                               Codigo ERP - Descrição |{' '}
//                             </strong>
//                             Sistema <strong id="white-bold-span">| </strong>
//                             Níveis / ...
//                           </span>
//                         </div>
//                       </Info.Root>
//                     </div>
//                     {catalogo.arranjoPagina && (
//                       <AsyncSelect
//                         id="idArranjo"
//                         name="idArranjo"
//                         placeholder="Digite para pesquisar um arranjo..."
//                         isClearable
//                         cacheOptions
//                         defaultOptions
//                         loadOptions={(value, cb) =>
//                           getArranjo({ id, value }, cb)
//                         }
//                         onChange={(data) => handleSerieArranjo(data)}
//                         width={270}
//                       />
//                     )}
//                     {/* <SearchAutocomplete
//                       fetchOptions={fetchOptions}
//                       fetchAll={fetchAll}
//                       onOptionSelected={(option) => {
//                         // o mesmo que você já faz em handlePagina(option)
//                         handlePagina(option);
//                       }}
//                       onSearchTerm={(term) => {
//                         // o mesmo que você já faz em handleFiltroAsyncSelect(term)
//                         handleFiltroAsyncSelect(term);
//                       }}
//                       initialQuery={
//                         new URLSearchParams(location.search).get('q') || ''
//                       }
//                     /> */}
//                     {/* <SearchAutocomplete
//                       idCatalogo={id}
//                       getMaterial={getMaterial}
//                       width={450}
//                       onOptionSelected={(option) => {
//                         handlePagina(option);
//                       }}
//                       onSearchTerm={(term) => {
//                         handleFiltroAsyncSelect(term);
//                       }}
//                       initialQuery={
//                         new URLSearchParams(location.search).get('q') || ''
//                       }
//                     /> */}
//                     <SearchAutocomplete
//                       idCatalogo={id}
//                       getMaterial={getMaterial}
//                       width={450}
//                       onOptionSelected={(option) => {
//                         const label = option?.label || {};

//                         if (label.partnumberPesquisadoEstaDesatualizado) {
//                           toast.info(
//                             `O partnumber ${label.partnumberPesquisado} foi encontrado no histórico, mas o atual agora é ${label.partnumberAtual}.`
//                           );
//                         }

//                         handlePagina(option);
//                       }}
//                       onSearchTerm={(term) => {
//                         handleFiltroAsyncSelect(term);
//                       }}
//                       initialQuery={
//                         new URLSearchParams(location.search).get('q') || ''
//                       }
//                     />
//                   </Form>
//                   {/* {dictaphoneEnabled && (
//                     <Dictaphone onTranscriptChange={setSpeechTranscript} />
//                   )} */}
//                   {/* <BtnFilter
//                     title="Filtrar páginas pelo termo digitado"
//                     onClick={() => {
//                       // handleFiltroAsyncSelect(valueAsyncSelect);
//                       // setSpeechTranscript('');
//                       const termo = formRef.current.getFieldValue('idMaterial');
//                       console.log(
//                         'BUTTON -> handleFiltroAsyncSelect disparada com termo:',
//                         termo
//                       );
//                       console.log(
//                         'BUTTON -> handleFiltroAsyncSelect disparada com valueAsyncSelect:',
//                         valueAsyncSelect
//                       );
//                       handleFiltroAsyncSelect(termo);
//                       setSpeechTranscript('');
//                       // setValueAsyncSelect(null);
//                     }}
//                   >
//                     <MdSearch size={20} />
//                   </BtnFilter> */}
//                   {/* <BtnFilter
//                     title="Filtrar páginas pelo termo digitado"
//                     // onClick={() => {
//                     //   handleFiltroAsyncSelect(valueAsyncSelect);
//                     //   setSpeechTranscript('');
//                     // }}
//                     onClick={() => {
//                       const termo = (valueAsyncSelect || '').trim();
//                       if (!termo) return;

//                       handleFiltroAsyncSelect(termo);

//                       // <<< mantém o termo visível no AsyncSelect >>>
//                       setSelectedOption({
//                         value: '__typed__',
//                         label: termo,
//                         __isTyped: true,
//                       });
//                       setValueAsyncSelect('');
//                       setIsEditing(false);

//                       setSpeechTranscript('');
//                     }}
//                   >
//                     <MdSearch size={20} />
//                   </BtnFilter> */}
//                 </Form.Row>
//               </Container.Header.Search>
//               {exibeIdiomaCatalogo && (
//                 <div
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     margin: 8,
//                   }}
//                 >
//                   <IdiomaCatalogoSelect
//                     value={idiomaCatalogo}
//                     onChange={(value) => dispatch(setIdiomaCatalogo(value))}
//                   />
//                 </div>
//               )}
//             </Container.Header>

//             <Wrapper>
//               {!pageMaximize && (
//                 <>
//                   <Menu>
//                     {catalogo && (
//                       <>
//                         {/**
//                          * Trilho sempre visível. O painel abaixo é sobreposto
//                          * ao conteúdo, preservando a largura do desenho.
//                          */}
//                         <Menu.BtnCollapse
//                           type="button"
//                           collapse={menuHidden ? 1 : 0}
//                           aria-expanded={!menuHidden}
//                           title={
//                             menuHidden
//                               ? `Abrir ${SYSTEM_TREE[idioma]}`
//                               : `Fechar ${SYSTEM_TREE[idioma]}`
//                           }
//                           onClick={handleToggleMenuSistemas}
//                         >
//                           <MdAccountTree size={20} />
//                           <span>{SYSTEM_TREE[idioma]}</span>
//                           {menuHidden ? (
//                             <MdChevronRight size={18} />
//                           ) : (
//                             <MdChevronLeft size={18} />
//                           )}
//                         </Menu.BtnCollapse>

//                         <Menu.Content hidden={menuHidden}>
//                           <Menu.Content.Header>
//                             <strong>
//                               <MdAccountTree size={16} />
//                               {SYSTEM_TREE[idioma]}
//                             </strong>
//                             <button
//                               type="button"
//                               title={`Fechar ${SYSTEM_TREE[idioma]}`}
//                               onClick={() => setMenuHidden(true)}
//                             >
//                               <MdClose size={18} />
//                             </button>
//                           </Menu.Content.Header>

//                           <Menu.Content.Filter>
//                             {catalogo.sistema && (
//                               <span>
//                                 {catalogo.sistema.descricao}
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     handleFiltro(
//                                       'FLT_IDS',
//                                       catalogo.sistema.codiSist
//                                     )
//                                   }
//                                 >
//                                   <MdClose size={12} />
//                                 </button>
//                               </span>
//                             )}

//                             {catalogo.local && (
//                               <span>
//                                 {catalogo.local.descricao}
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     handleFiltro(
//                                       'FLT_IDL',
//                                       catalogo.local.codiLoca
//                                     )
//                                   }
//                                 >
//                                   <MdClose size={12} />
//                                 </button>
//                               </span>
//                             )}
//                           </Menu.Content.Filter>

//                           <Menu.Content.TreeView>
//                             <TreeView data={catalogo} ref={refTtreeView} />
//                           </Menu.Content.TreeView>

//                           {/* <Menu.Content.File>
//                           <h4>Anexos</h4>
//                           <ul>
//                             <li>
//                               <a href="/#">NomeDaPeça.mp4</a>
//                             </li>
//                             <li>
//                               <a href="/#">ManualDaPeça.pdf</a>
//                             </li>
//                             <li>
//                               <a href="/#">DiagramaSecundario.pdf</a>
//                             </li>
//                           </ul>
//                         </Menu.Content.File> */}
//                         </Menu.Content>
//                       </>
//                     )}
//                   </Menu>
//                   {utilizaVisualizaoFacesSistema() && hasIDP && (
//                     <Menu>
//                       <Menu.BtnCollapse
//                         type="button"
//                         collapse={menuFacesHidden ? 1 : 0}
//                         aria-expanded={!menuFacesHidden}
//                         title={
//                           menuFacesHidden
//                             ? `Abrir ${SYSTEM_FACES[idioma]}`
//                             : `Fechar ${SYSTEM_FACES[idioma]}`
//                         }
//                         onClick={handleToggleMenuFaces}
//                       >
//                         <MdLayers size={20} />
//                         <span>{SYSTEM_FACES[idioma]}</span>
//                         {menuFacesHidden ? (
//                           <MdChevronRight size={18} />
//                         ) : (
//                           <MdChevronLeft size={18} />
//                         )}
//                       </Menu.BtnCollapse>

//                       <Menu.Content hidden={menuFacesHidden}>
//                         <Menu.Content.Header>
//                           <strong>
//                             <MdLayers size={16} />
//                             {SYSTEM_FACES[idioma]}
//                           </strong>
//                           <button
//                             type="button"
//                             title={`Fechar ${SYSTEM_FACES[idioma]}`}
//                             onClick={() => setMenuFacesHidden(true)}
//                           >
//                             <MdClose size={18} />
//                           </button>
//                         </Menu.Content.Header>

//                         <Menu.Content.TreeView>
//                           <SistemaFacesTree data={catalogo} hideHeader />
//                         </Menu.Content.TreeView>
//                       </Menu.Content>
//                     </Menu>
//                   )}
//                 </>
//               )}

//               <Content>
//                 <Content.ToolBar>
//                   {catalogo && handleBreadcrumb(catalogo)}

//                   {controle && (
//                     <Content.ToolBar.DrawControl>
//                       <button
//                         type="button"
//                         onClick={debounce(() => {
//                           handlePageNav(-1);
//                           handleScrollLinkTreeView();
//                         }, 100)}
//                       >
//                         <MdChevronLeft size={20} />
//                       </button>
//                       <span>{shownPage}</span>
//                       <button
//                         type="button"
//                         onClick={debounce(() => {
//                           handlePageNav(1);
//                           handleScrollLinkTreeView();
//                         }, 100)}
//                       >
//                         <MdChevronRight size={20} />
//                       </button>
//                       <button ref={zoomInRef} type="button">
//                         <MdZoomIn size={20} />
//                       </button>
//                       <button ref={zoomOutRef} type="button">
//                         <MdZoomOut size={20} />
//                       </button>
//                       <button ref={zoomResetRef} type="button">
//                         <MdYoutubeSearchedFor size={20} />
//                       </button>
//                       <button type="button" onClick={handleRedimensionar}>
//                         {pageMaximize ? (
//                           <MdFullscreenExit size={20} color="#ff6d3c" />
//                         ) : (
//                           <MdFullscreen size={20} />
//                         )}
//                       </button>
//                       {/* <button type="button" onClick={handleImprimir}>
//                         <MdPrint size={20} />
//                       </button> */}
//                       <button
//                         type="button"
//                         onClick={handlePDF}
//                         disabled={loadingButtonPrint}
//                       >
//                         {loadingButtonPrint ? (
//                           <GiSandsOfTime size={20} color="#ff6d3c" />
//                         ) : (
//                           <MdPrint size={20} />
//                         )}
//                       </button>
//                       <button
//                         type="button"
//                         onClick={handleMail}
//                         disabled={loadingButtonMail}
//                       >
//                         {loadingButtonMail ? (
//                           <GiSandsOfTime size={20} color="#ff6d3c" />
//                         ) : (
//                           <MdEmail size={20} />
//                         )}
//                       </button>
//                     </Content.ToolBar.DrawControl>
//                   )}
//                 </Content.ToolBar>

//                 {catalogo && handleContainer(catalogo)}
//               </Content>
//             </Wrapper>
//           </>
//         )}
//       </Container>
//     </>
//   );
// }

// export default Classificacao;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  MdSearch,
  MdYoutubeSearchedFor,
  MdZoomIn,
  MdZoomOut,
  MdFullscreen,
  MdFullscreenExit,
  MdPrint,
  MdChevronLeft,
  MdChevronRight,
  MdClose,
  MdEmail,
  MdHome,
  // MdStar,
  MdStarOutline,
  MdPictureAsPdf,
  MdAccountTree,
  MdLayers,
} from 'react-icons/md';

import { GiSandsOfTime } from 'react-icons/gi';

import { components } from 'react-select';

// import { border, borderRadius } from 'polished';
// import { borderRadius, padding } from 'polished';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import history from '../../../services/history';

import { AppError } from '../../../errors/AppError';

import {
  opEmpresa,
  // opSimNao,
  opTipoAcao,
  opTipoAcesso,
} from '../../../lib/const';
import { debounce } from '../../../lib/inputUtils';
import { initialParams } from '../../../lib/reactRouter';
import { getMaterial, getArranjo } from '../../../lib/asyncUtils';

import TreeView from '../../../components/TreeView';

import { Form } from '../../../components/Form';
import AsyncSelect from '../../../components/Form/Input/AsyncSelect';
import { Info } from '../../../components/Info';

import Listagem from './Listagem';
import Page from './Pagina';

import {
  Container,
  Wrapper,
  Menu,
  Content,
  WrapperTitleInfo,
  WrapperSubtitles,
  WrapperTittleInfoSubtitle,
  BtnFilter,
} from './styles';
import {
  handleHomeFilter,
  handleHomeFilterClear,
} from '../../../store/modules/homeFilter/actions';
import HoverImagePortal from '../../../components/HoverImagePortal';
import {
  adicionaCarrinhoArrayRequest,
  sharedManagementSet,
} from '../../../store/modules/cart/actions';
import Dictaphone from '../../../components/SpeechRecognition';
import {
  useDictaphone,
  utilizaVisualizaoFacesSistema,
  usaIdiomaCatalogo,
  usaPdfCatalogoCdi,
} from '../../../lib/paramUtils';
import { setIdiomaCatalogo } from '../../../store/modules/param/actions';
import IdiomaCatalogoSelect from '../../../components/IdiomaCatalogoSelect';
import SearchAutocomplete from '../../../components/Form/Input/SearchAutocomplete';
import SistemaFacesTree from '../../../components/SistemaFacesTree';
import {
  opIdiomaCatalogo,
  SYSTEM_FACES,
  SYSTEM_TREE,
} from '../../../lib/idiomaAppOptions';

function Classificacao() {
  const { id } = useParams();
  const location = useLocation();

  const dictaphoneEnabled = useDictaphone();

  const { app, action, signed, token } = useSelector(
    (state) => state.auth || {}
  );
  const { adm, empresa } = useSelector((state) => state.user.profile || {});
  const { homeFilter } = useSelector((state) => state || {});
  const { sharedManagement } = useSelector((state) => state.cart || {});

  /** idioma do catálogo escolhido pelo usuário (null = padrão) */
  const idiomaCatalogo = useSelector(
    (state) => state.param.idiomaCatalogo || null
  );
  const exibeIdiomaCatalogo = usaIdiomaCatalogo();
  const exibePdfCatalogoCdi = usaPdfCatalogoCdi();

  /** params de idioma para as chamadas (vazio quando não escolhido) */
  const idiomaParams =
    idiomaCatalogo !== null ? { idioma: idiomaCatalogo } : {};

  /** idioma efetivo para os rótulos das colunas laterais */
  const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

  /** referencia para atribuir controles de zoom */
  const zoomInRef = useRef();
  const zoomOutRef = useRef();
  const zoomResetRef = useRef();

  const formRef = useRef();
  const paginaRef = useRef();

  const refTtreeView = useRef(null);

  const dispatch = useDispatch();

  /**
   * Colunas laterais (árvore de sistemas / faces do sistema) iniciam
   * FECHADAS: em tablet (1340 x 800) a prioridade é o desenho da peça e a
   * tabela de itens. Os trilhos laterais permanecem visíveis para abrir e
   * fechar rapidamente, e os painéis são sobrepostos ao conteúdo.
   */
  const [menuHidden, setMenuHidden] = useState(true);
  const [menuFacesHidden, setMenuFacesHidden] = useState(true);
  const [pageMaximize, setPageMaximize] = useState(false);

  const [catalogo, setCatalogo] = useState(null);
  const [paginaCatalogo, setPaginaCatalogo] = useState([]);
  const [controle, setControle] = useState(false);
  const [shownPage, setShownPage] = useState(0);
  const [nSerie, setNSerie] = useState([]);
  const [catalogoPdf, setCatalogoPdf] = useState(null);

  const [loadingButtonPrint, setLoadingButtonPrint] = useState(false);
  const [loadingButtonMail, setLoadingButtonMail] = useState(false);

  const [fmtFilterSearch, setFmtFilterSearch] = useState([]);

  const [valueAsyncSelect, setValueAsyncSelect] = useState('');

  const [isHovered, setIsHovered] = useState(null);

  const [speechTranscript, setSpeechTranscript] = useState('');

  const selectMaterialRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState(null);
  // const [valueAsyncSelect, setValueAsyncSelect] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const prevQRef = useRef('');

  useEffect(() => {
    const q = new URLSearchParams(location.search).get('q') || '';
    if (q !== prevQRef.current) {
      setValueAsyncSelect(q);
      // Se ainda não existe seleção real, mantém o "valor sintético" para exibir o texto
      setSelectedOption((curr) => {
        if (!q) return null;
        if (!curr || curr.__isTyped) {
          return { value: '__typed__', label: q, __isTyped: true };
        }
        return curr; // mantém a seleção real
      });
      prevQRef.current = q;
    }
  }, [location.search]);

  useEffect(() => {
    api
      .get(`/catalogo-navegacao/${id}/pagina`, {
        params: { ...idiomaParams },
      })
      .then((response) => {
        setPaginaCatalogo(response.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, idiomaCatalogo]);

  useEffect(() => {
    if (Array.isArray(homeFilter.paginas) && homeFilter.paginas.length > 0) {
      setFmtFilterSearch(
        paginaCatalogo.filter((i) =>
          homeFilter.paginas.some((j) => i.idPagina === j.idPagina)
        )
      );
    } else {
      setFmtFilterSearch(paginaCatalogo);
    }
  }, [paginaCatalogo, homeFilter]);

  useEffect(() => {
    /** pega parâmetros da rota */
    const paramQuery = new URLSearchParams(location.search);

    const paramRoute = {
      ...initialParams,
      ...Object.fromEntries(paramQuery),
    };

    api
      .get(`/catalogo-navegacao/${id}`, {
        params: {
          ...paramRoute,
          ...idiomaParams,
        },
      })
      .then((response) => {
        setCatalogo(response.data);

        /** Preenchimento do campos arranjo */
        const { arranjo } = response.data;

        if (arranjo && formRef.current) {
          const valorAtual = formRef.current.getFieldValue('idArranjo');
          if (!valorAtual) {
            formRef.current.setFieldValue('idArranjo', {
              label: `N/S: ${arranjo.numeroSerie} - ${arranjo.nome}`,
              value: `${arranjo.idSerie}.${arranjo.idArranjo}`,
            });
          }
        }
      })
      .catch((err) => {
        AppError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, location, idiomaCatalogo]);

  useEffect(() => {
    api
      .get(`/catalogo/${id}`)
      .then((response) => {
        setCatalogoPdf(response.data.arquivo.url);
        setNSerie(response.data.series || []);
      })
      .catch((err) => {
        AppError(err);
      });
  }, [id]);

  useEffect(() => {
    /** pega parâmetros da rota */
    const paramQuery = new URLSearchParams(location.search);

    setControle(paramQuery.has('IDP'));
    if (catalogo && paramQuery.has('IDP')) {
      const page = Number(paramQuery.get('IDP'));

      const { paginas = [] } = catalogo;

      const index = paginas.findIndex((p) => p === page);
      if (index >= 0) setShownPage(index + 1);

      if (homeFilter.value !== null) {
        const indexHomeFilter = fmtFilterSearch.findIndex(
          (p) => p.idPagina === page
        );
        if (indexHomeFilter >= 0) setShownPage(indexHomeFilter + 1);
      }
    }
  }, [location, catalogo, homeFilter, fmtFilterSearch]);

  // const handleFiltroAsyncSelect = useCallback(
  //   (value) => {
  //     api
  //       .get(`/catalogo-filtro/${id}/material-catalogo`, {
  //         params: {
  //           q: value,
  //         },
  //       })
  //       .then((response) => {
  //         const { searchHandle, paginas, paginasERP } = response.data;

  //         // console.log(value);

  //         dispatch(handleHomeFilter(value, searchHandle, paginas, paginasERP));
  //       })
  //       .catch((error) => {
  //         console.error('Erro ao filtrar:', error);
  //       })
  //       .finally(() => {
  //         // setValueAsyncSelect(null);
  //         // setValueAsyncSelect('');
  //         // history.push(`/catalogo.partes/${id}`);
  //         history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);
  //       });

  //     // history.push(`/catalogo.partes/${id}`);
  //   },
  //   [id, dispatch]
  // );

  // const handleFiltroAsyncSelect = useCallback(
  //   (value) => {
  //     api
  //       .get(`/catalogo-filtro/${id}/material-catalogo`, {
  //         params: { q: value },
  //       })
  //       .then((response) => {
  //         const { searchHandle, paginas, paginasERP } = response.data;
  //         dispatch(handleHomeFilter(value, searchHandle, paginas, paginasERP));
  //       })
  //       .catch((error) => console.error('Erro ao filtrar:', error))
  //       .finally(() => {
  //         history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);
  //         setTimeout(() => {
  //           try {
  //             const el = selectMaterialRef.current;
  //             if (el && typeof el.focus === 'function') {
  //               el.focus();
  //             }
  //           } catch (err) {
  //             console.error('Erro ao devolver foco:', err);
  //           }
  //         }, 0);
  //       });
  //   },
  //   [id, dispatch]
  // );

  const handleFiltroAsyncSelect = useCallback(
    (value) => {
      api
        .get(`/catalogo-filtro/${id}/material-catalogo`, {
          params: { q: value, ...idiomaParams },
        })
        .then((response) => {
          const {
            searchHandle,
            paginas,
            paginasERP,
            avisosPartnumber = [],
          } = response.data;

          dispatch(
            handleHomeFilter(
              value,
              searchHandle,
              paginas,
              paginasERP,
              avisosPartnumber
            )
          );

          if (avisosPartnumber.length === 1) {
            const aviso = avisosPartnumber[0];

            toast.info(
              `O partnumber ${aviso.partnumberPesquisado} foi encontrado no histórico, mas o atual agora é ${aviso.partnumberAtual}.`
            );
          }

          if (avisosPartnumber.length > 1) {
            toast.info(
              `${avisosPartnumber.length} itens encontrados possuem partnumber atualizado. Veja os avisos na tela.`
            );
          }
        })
        .catch((error) => console.error('Erro ao filtrar:', error))
        .finally(() => {
          history.push(`/catalogo.partes/${id}?q=${encodeURIComponent(value)}`);

          setTimeout(() => {
            try {
              const el = selectMaterialRef.current;
              if (el && typeof el.focus === 'function') {
                el.focus();
              }
            } catch (err) {
              console.error('Erro ao devolver foco:', err);
            }
          }, 0);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, dispatch, idiomaCatalogo]
  );

  const handleAbrirPdfCatalogo = useCallback(() => {
    api
      .get(`/pdf-catalogo/${id}`)
      .then((response) => {
        const { existe, url, mensagem } = response.data || {};

        if (existe && url) {
          window.open(url, '_blank');
        } else {
          toast.warn(mensagem || 'O catálogo não foi gerado.');
        }
      })
      .catch(() => {
        toast.error('Não foi possível verificar o PDF do catálogo.');
      });
  }, [id]);

  // const handleFiltroPaginas = useCallback(() => {
  //   // const { value, searchHandle, paginas, paginasERP } = homeFilter;

  //   // console.log(value, searchHandle, paginas, paginasERP);

  //   // levar para pagina de busca das páginas com o value pesquisado
  //   // history.push(`/catalogo.partes/${id}/paginas-filtro`);

  //   console.log('TESTE');
  // }, [history, id]);

  const handlePagina = useCallback(
    (data) => {
      // const { value = '' } = data || {};
      const { value = '', label = {} } = data || {};
      const [, idPagina] = value.split('.');

      if (idPagina) {
        const { niveis = [] } =
          paginaCatalogo.find((p) => p.idPagina === Number(idPagina)) || {};

        const searchLocation = [];

        /** processa os níveis da página */
        // niveis.forEach((itemNivel) => {
        //   searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
        // });

        /** mantém os filtros já aplicados antes de abrir a página do item */
        const paramQuery = new URLSearchParams(location.search);
        ['FLT_IDS', 'FLT_IDL', 'FLT_IDE', 'FLT_IDA'].forEach((key) => {
          const paramValue = paramQuery.get(key);
          if (paramValue) searchLocation.push(`${key}=${paramValue}`);
        });

        /**
         * Usa a hierarquia retornada pela própria busca quando disponível.
         * Isso evita abrir a página com IDN incompleto/incorreto e mantém
         * a árvore de Faces do Sistema limitada ao sistema da página clicada.
         */
        if (label.paginaNivelURL) {
          searchLocation.push(label.paginaNivelURL);
        } else {
          niveis.forEach((itemNivel) => {
            searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
          });
        }

        /** processa página */
        searchLocation.push(`IDP=${idPagina}`);
        /** processa item */
        // searchLocation.push(`IDI=${data.value}`);
        searchLocation.push(`IDI=${value}`);

        /** Adiciona materila ERP URL para ser filtrado e selecionado no ItemCart */
        // if (data.label.codimate) {
        //   searchLocation.push(`ERP=${data.label.codimate}`);
        // }

        /** Adiciona material ERP na URL para ser selecionado no ItemCart */
        if (label.codimate) {
          searchLocation.push(`ERP=${label.codimate}`);
        }

        history.push(`${id}?${searchLocation.join('&')}`);

        // devolve o foco para continuar exibindo o texto digitado
        setTimeout(() => {
          try {
            const el = selectMaterialRef.current;
            if (el && typeof el.focus === 'function') el.focus();
          } catch (err) {
            console.error('Erro ao devolver foco:', err);
          }
        }, 0);
      }
    },
    // [id, paginaCatalogo]
    [id, paginaCatalogo, location.search]
  );

  const handleSerieArranjo = useCallback(
    (data) => {
      const params = [];

      /** separa valores "serie.arranjo" */
      const { value = '' } = data || {};
      const [serie, arranjo] = value.split('.');

      /** pega parâmetros da rota */
      const paramQuery = new URLSearchParams(location.search);
      const paramRoute = {
        ...initialParams,
        ...Object.fromEntries(paramQuery),
      };

      /** processa os parâmetros de sistema e local caso eles existam no primeiro ciclo */
      const { FLT_IDS: fltIdS, FLT_IDL: fltIdL } = paramRoute;
      if (fltIdS) params.push(`FLT_IDS=${fltIdS}`);
      if (fltIdL) params.push(`FLT_IDL=${fltIdL}`);

      /** processa arranjo */
      if (serie && arranjo) {
        params.push(`FLT_IDE=${serie}`);
        params.push(`FLT_IDA=${arranjo}`);
      }

      /** monta rota para redirecionamento */
      const routeParam = `?${params.join('&')}`;

      if (location.search !== routeParam)
        history.push(location.pathname + routeParam);
    },
    [location]
  );

  // const handlePageNavFilter = useCallback((step) => {
  //   if (homeFilter.value !== null) {
  //     const currentPage = paginaCatalogo[shownPage - 1];

  //     console.log(currentPage);

  //     const indexCurrentPage = fmtFilterSearch.indexOf(
  //       fmtFilterSearch.find((i) => i.idPagina === currentPage.idPagina)
  //     );

  //     console.log('indexCurrentPage...', indexCurrentPage);
  //     console.log(
  //       'fmtFilterSearch[indexCurrentPage + step]...',
  //       fmtFilterSearch[indexCurrentPage + step]
  //     );

  //     if (fmtFilterSearch[indexCurrentPage + step] === undefined) return;

  //     const { idPagina, niveis } = fmtFilterSearch[indexCurrentPage + step];
  //     const { idCatalogo } = catalogo;

  //     const searchLocation = [];

  //     niveis.forEach((itemNivel) => {
  //       searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
  //     });

  //     searchLocation.push(`IDP=${idPagina}`);

  //     history.push(`${idCatalogo}?${searchLocation.join('&')}`);
  //   }
  // }, []);

  const handlePageNav = useCallback(
    (step) => {
      if (catalogo && step !== 0) {
        const nextPage = shownPage - 1 + step;

        // console.log('\n paginaCatalogo...', paginaCatalogo);
        // console.log('homeFilter...', homeFilter);
        // console.log('fmtFilterSearch...', fmtFilterSearch);

        // console.log('shownPage, step...', shownPage, step);
        // console.log(
        //   'nextPage, fmtFilterSearch.length...',
        //   nextPage,
        //   fmtFilterSearch.length
        // );

        if (homeFilter.value !== null) {
          const currentPage = fmtFilterSearch[shownPage - 1];

          // console.log(currentPage);

          const indexCurrentPage = fmtFilterSearch.indexOf(
            fmtFilterSearch.find((i) => i.idPagina === currentPage.idPagina)
          );

          // console.log('indexCurrentPage...', indexCurrentPage);
          // console.log(
          //   'fmtFilterSearch[indexCurrentPage + step]...',
          //   fmtFilterSearch[indexCurrentPage + step]
          // );

          if (fmtFilterSearch[indexCurrentPage + step] === undefined) return;

          const { idPagina, niveis } = fmtFilterSearch[indexCurrentPage + step];
          const { idCatalogo } = catalogo;

          const searchLocation = [];

          niveis.forEach((itemNivel) => {
            searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
          });

          searchLocation.push(`IDP=${idPagina}`);

          history.push(`${idCatalogo}?${searchLocation.join('&')}`);
        }

        /** Navega para a página encontrada */
        if (
          homeFilter.value === null &&
          nextPage >= 0 &&
          nextPage < paginaCatalogo.length
        ) {
          const { idPagina, niveis } = paginaCatalogo[nextPage];

          const { idCatalogo, paginas = [] } = catalogo;

          /** verifica se a página não está filtrada */
          if (paginas.find((p) => p === idPagina)) {
            const searchLocation = [];

            /** pega parâmetros da rota */
            const paramQuery = new URLSearchParams(location.search);
            const paramRoute = {
              ...initialParams,
              ...Object.fromEntries(paramQuery),
            };

            /** processa os parâmetros de sistema, local e pesquisa caso eles existam no primeiro ciclo */
            const {
              FLT_IDS: fltIdS,
              FLT_IDL: fltIdL,
              FLT_IDE: fltIdE,
              FLT_IDA: fltIdA,
              q: fltSearch,
            } = paramRoute;
            if (fltIdS) searchLocation.push(`FLT_IDS=${fltIdS}`);
            if (fltIdL) searchLocation.push(`FLT_IDL=${fltIdL}`);
            if (fltIdE) searchLocation.push(`FLT_IDE=${fltIdE}`);
            if (fltIdA) searchLocation.push(`FLT_IDA=${fltIdA}`);
            if (fltSearch) searchLocation.push(`q=${fltSearch}`);

            /** processa os níveis da página */
            niveis.forEach((itemNivel) => {
              searchLocation.push(`IDN_${itemNivel.codigo}=${itemNivel.id}`);
            });

            /** processa página */
            searchLocation.push(`IDP=${idPagina}`);

            /** monta rota para redirecionamento */
            history.push(`${idCatalogo}?${searchLocation.join('&')}`);
          }
        }
      }
    },
    [location, catalogo, paginaCatalogo, shownPage, fmtFilterSearch, homeFilter]
  );

  // const handleImprimir = useCallback(() => {
  //   /** chama função de impressão do componente filho */
  //   if (paginaRef.current) {
  //     paginaRef.current.handleImprimirPagina();
  //   }
  // }, []);

  const handlePDF = useCallback(async () => {
    setLoadingButtonPrint(true);
    /** chama função de impressão do componente filho */
    if (paginaRef.current) {
      paginaRef.current.handleImprimirPagina(false, setLoadingButtonPrint);
    }
  }, []);

  const handleMail = useCallback(() => {
    setLoadingButtonMail(true);
    /** chama função de impressão do componente filho */
    if (paginaRef.current) {
      paginaRef.current.handleImprimirPagina(true, setLoadingButtonMail);
    }
  }, []);

  const handleRedimensionar = useCallback(() => {
    setPageMaximize((state) => !state);

    /** chama função de redimensionamento do componente filho */
    if (paginaRef.current) {
      paginaRef.current.handleRedimensionarPagina(!pageMaximize);
    }
  }, [pageMaximize]);

  const handleFiltro = useCallback(
    (key) => {
      dispatch(handleHomeFilterClear());
      /** pega parâmetros da rota */
      const paramQuery = new URLSearchParams(location.search);

      const params = [];
      paramQuery.forEach((param, index) => {
        if (index !== key) {
          params.push(`${index}=${param}`);
        }
      });

      const routeParam = `?${params.join('&')}`;

      history.push(location.pathname + routeParam);
    },
    [location, dispatch]
  );

  const handleBreadcrumb = useCallback(
    (data) => {
      const breadcrumbs = [];
      const url = [];

      /** pega parâmetros da rota */
      const paramQuery = new URLSearchParams(location.search);
      const paramRoute = {
        ...initialParams,
        ...Object.fromEntries(paramQuery),
      };

      /** processa os parâmetros de sistema, local e pesquisa caso eles existam */
      const {
        FLT_IDS: fltIdS,
        FLT_IDL: fltIdL,
        FLT_IDE: fltIdE,
        FLT_IDA: fltIdA,
        q: fltSearch,
      } = paramRoute;
      if (fltIdS) url.push(`FLT_IDS=${fltIdS}`);
      if (fltIdL) url.push(`FLT_IDL=${fltIdL}`);
      if (fltIdE) url.push(`FLT_IDE=${fltIdE}`);
      if (fltIdA) url.push(`FLT_IDA=${fltIdA}`);
      if (fltSearch) url.push(`q=${fltSearch}`);

      const { idCatalogo, nome, treeView } = data;

      breadcrumbs.push({
        name: nome,
        url:
          url.length > 0 ? `${idCatalogo}?${url.join('&')}` : `${idCatalogo}`,
      });

      let currNode = treeView;

      Object.keys(paramRoute).forEach((paramAtual) => {
        /** monta breadcrumb */
        if (paramAtual.startsWith('IDN_') || paramAtual.startsWith('IDP')) {
          const [, key] = paramAtual.split('_');

          /** monta url para acesso */
          url.push(`${paramAtual}=${paramRoute[paramAtual]}`);

          const itemNode = currNode.find(
            (n) =>
              n.codigo === (Number(key) || idCatalogo) &&
              n.id === Number(paramRoute[paramAtual])
          );

          if (itemNode) {
            const { descricao } = itemNode;

            breadcrumbs.push({
              name: descricao,
              url: `?${url.join('&')}`,
            });

            /** atualiza item da treeview */
            if (itemNode.itens) currNode = itemNode.itens;
          }
        }
      });

      const { name = '' } = breadcrumbs[breadcrumbs.length - 1] || {};

      return (
        <Content.ToolBar.Header>
          {homeFilter.value && (
            <div>
              <h5>Filtrado por: </h5>
              <span>{homeFilter.value}</span>
              <button
                type="button"
                title="Limpar filtro"
                onClick={() => {
                  dispatch(handleHomeFilterClear());
                  history.push(`/catalogo.partes/${id}`);
                }}
              >
                <MdClose size={20} />
              </button>
            </div>
          )}
          {Array.isArray(homeFilter.avisosPartnumber) &&
            homeFilter.avisosPartnumber.length > 0 && (
              <div
                style={{
                  marginTop: 8,
                  marginBottom: 8,
                  padding: '10px 12px',
                  border: '1px solid #f59e0b',
                  borderRadius: 8,
                  background: '#fffbeb',
                  color: '#92400e',
                  fontSize: 13,
                  lineHeight: 1.4,
                }}
              >
                <strong>Partnumber atualizado:</strong>

                {homeFilter.avisosPartnumber.slice(0, 3).map((aviso) => (
                  <div
                    key={`${aviso.idMaterial}-${aviso.idPagina}-${aviso.idItem}`}
                  >
                    O partnumber pesquisado{' '}
                    <strong>{aviso.partnumberPesquisado}</strong> pertence ao
                    histórico deste item, mas o partnumber atual agora é{' '}
                    <strong>{aviso.partnumberAtual}</strong>.
                  </div>
                ))}

                {homeFilter.avisosPartnumber.length > 3 && (
                  <div>
                    Existem mais {homeFilter.avisosPartnumber.length - 3} itens
                    com histórico de alteração de partnumber.
                  </div>
                )}
              </div>
            )}
          <h3>{name}</h3>
          {/* {breadcrumbs.map((bread, index, array) => {
            const label =
              array.length - 1 === index ? bread.name : `${bread.name} / `;

            return (
              <Link
                key={index}
                to={bread.url}
                onClick={() => dispatch(handleHomeFilterClear())}
              >
                {label}
              </Link>
            );
          })} */}
          {breadcrumbs.map((bread, index, array) => {
            const isLast = array.length - 1 === index;
            return (
              <span key={bread.url || index}>
                {isLast ? (
                  <span aria-current="page">{bread.name}</span>
                ) : (
                  <Link
                    to={bread.url}
                    onClick={() => dispatch(handleHomeFilterClear())}
                  >
                    {bread.name}
                  </Link>
                )}
                {!isLast && <span aria-hidden="true"> / </span>}
              </span>
            );
          })}

          {/* seta de "voltar" para o penúltimo breadcrumb */}
          {/* {breadcrumbs.length > 1 && (
            <Link
              to={breadcrumbs[breadcrumbs.length - 2].url}
              onClick={() => dispatch(handleHomeFilterClear())}
              aria-label={`Voltar para ${
                breadcrumbs[breadcrumbs.length - 2].name
              }`}
              className="breadcrumb-back"
            >
              ← <span className="sr-only">Voltar</span>
            </Link>
          )} */}

          {breadcrumbs.length > 1 && (
            <Link
              to={breadcrumbs[breadcrumbs.length - 2].url}
              onClick={() => dispatch(handleHomeFilterClear())}
              className="breadcrumb-back"
              aria-label={`${breadcrumbs[breadcrumbs.length - 2].name}`}
              title={`${breadcrumbs[breadcrumbs.length - 2].name}`}
              style={{
                marginLeft: '3px',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '2px',
                borderRadius: 999,
                border: '1px solid #2c405a',
              }}
            >
              <MdChevronLeft size={16} color="#2c405a" />
            </Link>
          )}
        </Content.ToolBar.Header>
      );
    },
    [location, dispatch, homeFilter, id]
  );

  const handleContainer = useCallback(
    (data) => {
      const { idCatalogo } = data;

      /** pega parâmetros da rota */
      const paramQuery = new URLSearchParams(location.search);

      // console.log(location.search);
      // console.log(data);

      return paramQuery.has('IDP') ? (
        <Page
          ref={paginaRef}
          id={idCatalogo}
          idPagina={Number(paramQuery.get('IDP'))}
          zoomInRef={zoomInRef}
          zoomOutRef={zoomOutRef}
          zoomResetRef={zoomResetRef}
        />
      ) : (
        <Listagem data={data} />
        // <>
        //   <Listagem data={data} />
        //   <SistemaFacesTree data={catalogo} />
        // </>
      );
    },
    [location]
  );

  useEffect(() => {
    async function addCart(output, idCatalogo) {
      return dispatch(adicionaCarrinhoArrayRequest(idCatalogo, output));
    }
    async function fetchData() {
      try {
        const response = await api.get(`app.session/${token}`);
        const { data } = response;

        const { info, idCatalogo } = data;

        const fmtOutputInfo = [];

        if (info) {
          const fmtInfo = info.split('&');

          fmtInfo.forEach((i, index) => {
            if (i.includes('IDPAG_')) {
              fmtOutputInfo.push({
                idPagina: Number(
                  fmtInfo[index].split('=')[1].replaceAll(',', '')
                ),
                idItem: String(
                  fmtInfo[index + 1].split('=')[1].replaceAll(',', '')
                ),
                idMaterial: Number(
                  fmtInfo[index + 2].split('=')[1].replaceAll(',', '')
                ),
                codimate:
                  String(
                    fmtInfo[index + 3].split('=')[1].replaceAll(',', '')
                  ) !== 'undefined'
                    ? String(
                        fmtInfo[index + 3].split('=')[1].replaceAll(',', '')
                      )
                    : null,
                quantidade: Number(
                  fmtInfo[index + 4].split('=')[1].replaceAll(',', '')
                ),
                imagemCatalogo: String(
                  fmtInfo[index + 5].split('=')[1].replaceAll(',', '')
                ),
              });
            }
          });
        }

        await addCart(fmtOutputInfo, idCatalogo);

        if (info && !sharedManagement) {
          dispatch(sharedManagementSet(true));
          toast.info('Existem itens no carrinho que foram compartilhados!');
          history.push(`/carrinho`);
        }
      } catch (error) {
        toast.error(`Erro ao carregar o compartilhamento ${error}`);
      }
    }

    fetchData();
  }, [token, dispatch, sharedManagement]);

  const Group = (props) => <components.Group {...props} />;

  // console.log(homeFilter);
  // console.log(catalogo);

  const handleScrollLinkTreeView = () => {
    /** o painel pode estar fechado; nesse caso não há o que rolar */
    if (!refTtreeView.current) return;

    const links = refTtreeView.current.querySelectorAll('a');

    links.forEach((elemento) => {
      const linkSelecionado = elemento.getAttribute('data-selected');
      if (linkSelecionado === 'true') {
        setTimeout(() => {
          elemento.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }, 1000);
      }
    });
  };

  /**
   * Abre/fecha a coluna da árvore de sistemas.
   * Os painéis são sobrepostos ao conteúdo, portanto apenas um permanece
   * aberto por vez para não haver disputa de espaço na tela.
   */
  const handleToggleMenuSistemas = () => {
    setMenuHidden((state) => {
      if (state) setMenuFacesHidden(true);
      return !state;
    });
  };

  /** Abre/fecha a coluna das faces do sistema. */
  const handleToggleMenuFaces = () => {
    setMenuFacesHidden((state) => {
      if (state) setMenuHidden(true);
      return !state;
    });
  };

  /**
   * Como os painéis laterais são sobrepostos ao conteúdo, a tecla Esc os
   * fecha — atalho esperado para painéis desse tipo.
   */
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key !== 'Escape') return;

      setMenuHidden(true);
      setMenuFacesHidden(true);
    };

    window.addEventListener('keydown', handleEsc);

    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  // useEffect(() => {
  //   if (dictaphoneEnabled && speechTranscript !== '') {
  //     const newValue = speechTranscript.replaceAll('.', '');
  //     console.log('Atualizando AsyncSelect com transcript:', newValue);
  //     setValueAsyncSelect(newValue);
  //     if (formRef.current) {
  //       const form = formRef.current.getData();
  //       form.idMaterial = newValue;
  //       formRef.current.setData(form);
  //     }
  //     // disparar a busca automaticamente
  //     handleFiltroAsyncSelect(newValue);

  //     setSpeechTranscript('');
  //   }
  // }, [dictaphoneEnabled, speechTranscript, id]);

  useEffect(() => {
    if (dictaphoneEnabled && speechTranscript !== '') {
      const newValue = speechTranscript.replaceAll('.', '');
      setValueAsyncSelect(newValue);
      setSelectedOption({
        value: '__typed__',
        label: newValue,
        __isTyped: true,
      });

      if (formRef.current) {
        const form = formRef.current.getData();
        form.idMaterial = newValue;
        formRef.current.setData(form);
      }

      handleFiltroAsyncSelect(newValue);

      setSelectedOption({
        value: '__typed__',
        label: newValue,
        __isTyped: true,
      });
      setValueAsyncSelect('');
      setIsEditing(false);

      setSpeechTranscript('');
    }
  }, [dictaphoneEnabled, speechTranscript, id]);

  // useEffect(() => {
  //   if (formRef.current) {
  //     const form = formRef.current.getData();

  //     if (form.idMaterial !== valueAsyncSelect) {
  //       form.idMaterial = valueAsyncSelect;
  //       formRef.current.setData(form);
  //     }
  //   }
  // }, [valueAsyncSelect]);

  // adapters para sua API existente:
  const fetchOptions = (q) =>
    new Promise((resolve) => getMaterial({ id, value: q }, resolve));

  const fetchAll = () => fetchOptions(''); // ou crie um endpoint dedicado para "todos"

  const paramRoute = new URLSearchParams(location.search);
  const hasIDP = paramRoute.has('IDP');

  /** a coluna de faces só existe em uma página do catálogo (IDP na rota) */
  const exibeColunaFaces = utilizaVisualizaoFacesSistema() && hasIDP;

  return (
    <>
      <Container>
        {catalogo && (
          <>
            <Container.Header>
              {[opTipoAcao.PLATAFORMA, opTipoAcao.INTEGRACAO_CONSULTA].includes(
                action
              ) && (
                <Container.Header.BtnBack
                  title="Voltar para a Home"
                  onClick={() => {
                    dispatch(handleHomeFilterClear());
                    history.push('/');
                  }}
                >
                  <MdHome size={30} />
                </Container.Header.BtnBack>
              )}
              {/* {empresa.idEmpresa === opEmpresa.DMB && (
                <Container.Header.DownloadPdf
                  title="Download catálogo pdf completo"
                  href={catalogoPdf}
                  target="_blank"
                >
                  <MdPictureAsPdf size={30} />
                </Container.Header.DownloadPdf>
              )} */}
              {exibePdfCatalogoCdi && (
                <Container.Header.DownloadPdf
                  as="button"
                  type="button"
                  title="Abrir PDF completo do catálogo"
                  onClick={handleAbrirPdfCatalogo}
                >
                  <MdPictureAsPdf size={30} />
                </Container.Header.DownloadPdf>
              )}
              <WrapperTittleInfoSubtitle>
                <WrapperTitleInfo>
                  <Container.Header.Title>
                    {catalogo.nome}

                    {(catalogo || catalogo.arquivo) && (
                      <Info.Root topIcon="0" rightIcon="-5px">
                        {nSerie && nSerie.length > 0 && (
                          <div>
                            <strong>S/N:</strong>
                            {nSerie.map((item) => item.numeroSerie).join(',')}
                          </div>
                        )}
                        {catalogo.arquivo.fabricante && (
                          <div>
                            <strong>Fabricante:</strong>
                            {catalogo.arquivo.fabricante.descricao}
                          </div>
                        )}
                        {catalogo.arquivo.modelos &&
                          catalogo.arquivo.modelos.length > 0 && (
                            <div>
                              <strong>Modelo:</strong>
                              {catalogo.arquivo.modelos
                                .map((item) => item.descricao)
                                .join(',')}
                            </div>
                          )}
                        {catalogo.versao && (
                          <div>
                            <strong>Versão:</strong>
                            {catalogo.versao}
                          </div>
                        )}
                      </Info.Root>
                    )}
                  </Container.Header.Title>
                </WrapperTitleInfo>
                <WrapperSubtitles>
                  <Container.Header.Subtitle>
                    {catalogo.arquivo.fabricante.descricao}
                  </Container.Header.Subtitle>
                  <Container.Header.Subtitle>-</Container.Header.Subtitle>
                  <Container.Header.Subtitle>
                    {catalogo.arquivo.modelos
                      .map((item) => item.descricao)
                      .join(' | ')}
                  </Container.Header.Subtitle>
                </WrapperSubtitles>
              </WrapperTittleInfoSubtitle>

              {[opTipoAcao.INTEGRACAO_CATALOGO].includes(action) &&
                [opTipoAcesso.CLIENTE].includes(Number(adm)) &&
                signed && (
                  <Container.Header.BtnFavorite title="Solicitar ao fornecedor para manter o acesso ao catálogo">
                    <MdStarOutline size={25} />
                  </Container.Header.BtnFavorite>
                )}
              {/* {exibeIdiomaCatalogo && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: 12,
                  }}
                >
                  <IdiomaCatalogoSelect
                    value={idiomaCatalogo}
                    onChange={(value) => dispatch(setIdiomaCatalogo(value))}
                  />
                </div>
              )} */}
              <Container.Header.Search>
                <Form.Row>
                  <Form ref={formRef}>
                    <div
                      style={{
                        position: 'relative',
                      }}
                    >
                      <Info.Root rightIcon="470px" topIcon="7px">
                        <div>
                          <span id="grey-italic-span">
                            <strong id="white-bold-span">
                              Partnumber - Descrição |{' '}
                            </strong>
                            Sistema <strong id="white-bold-span">| </strong>
                            Níveis / ...
                          </span>
                        </div>
                        <div>
                          <span id="grey-italic-padding-span">OU</span>
                        </div>
                        <div>
                          <span id="grey-italic-span">
                            <strong id="white-bold-span">
                              Codigo ERP - Descrição |{' '}
                            </strong>
                            Sistema <strong id="white-bold-span">| </strong>
                            Níveis / ...
                          </span>
                        </div>
                      </Info.Root>
                    </div>
                    {catalogo.arranjoPagina && (
                      <AsyncSelect
                        id="idArranjo"
                        name="idArranjo"
                        placeholder="Digite para pesquisar um arranjo..."
                        isClearable
                        cacheOptions
                        defaultOptions
                        loadOptions={(value, cb) =>
                          getArranjo({ id, value }, cb)
                        }
                        onChange={(data) => handleSerieArranjo(data)}
                        width={270}
                      />
                    )}
                    {/* <SearchAutocomplete
                      fetchOptions={fetchOptions}
                      fetchAll={fetchAll}
                      onOptionSelected={(option) => {
                        // o mesmo que você já faz em handlePagina(option)
                        handlePagina(option);
                      }}
                      onSearchTerm={(term) => {
                        // o mesmo que você já faz em handleFiltroAsyncSelect(term)
                        handleFiltroAsyncSelect(term);
                      }}
                      initialQuery={
                        new URLSearchParams(location.search).get('q') || ''
                      }
                    /> */}
                    {/* <SearchAutocomplete
                      idCatalogo={id}
                      getMaterial={getMaterial}
                      width={450}
                      onOptionSelected={(option) => {
                        handlePagina(option);
                      }}
                      onSearchTerm={(term) => {
                        handleFiltroAsyncSelect(term);
                      }}
                      initialQuery={
                        new URLSearchParams(location.search).get('q') || ''
                      }
                    /> */}
                    <SearchAutocomplete
                      idCatalogo={id}
                      getMaterial={getMaterial}
                      width={450}
                      onOptionSelected={(option) => {
                        const label = option?.label || {};

                        if (label.partnumberPesquisadoEstaDesatualizado) {
                          toast.info(
                            `O partnumber ${label.partnumberPesquisado} foi encontrado no histórico, mas o atual agora é ${label.partnumberAtual}.`
                          );
                        }

                        handlePagina(option);
                      }}
                      onSearchTerm={(term) => {
                        handleFiltroAsyncSelect(term);
                      }}
                      initialQuery={
                        new URLSearchParams(location.search).get('q') || ''
                      }
                    />
                  </Form>
                  {/* {dictaphoneEnabled && (
                    <Dictaphone onTranscriptChange={setSpeechTranscript} />
                  )} */}
                  {/* <BtnFilter
                    title="Filtrar páginas pelo termo digitado"
                    onClick={() => {
                      // handleFiltroAsyncSelect(valueAsyncSelect);
                      // setSpeechTranscript('');
                      const termo = formRef.current.getFieldValue('idMaterial');
                      console.log(
                        'BUTTON -> handleFiltroAsyncSelect disparada com termo:',
                        termo
                      );
                      console.log(
                        'BUTTON -> handleFiltroAsyncSelect disparada com valueAsyncSelect:',
                        valueAsyncSelect
                      );
                      handleFiltroAsyncSelect(termo);
                      setSpeechTranscript('');
                      // setValueAsyncSelect(null);
                    }}
                  >
                    <MdSearch size={20} />
                  </BtnFilter> */}
                  {/* <BtnFilter
                    title="Filtrar páginas pelo termo digitado"
                    // onClick={() => {
                    //   handleFiltroAsyncSelect(valueAsyncSelect);
                    //   setSpeechTranscript('');
                    // }}
                    onClick={() => {
                      const termo = (valueAsyncSelect || '').trim();
                      if (!termo) return;

                      handleFiltroAsyncSelect(termo);

                      // <<< mantém o termo visível no AsyncSelect >>>
                      setSelectedOption({
                        value: '__typed__',
                        label: termo,
                        __isTyped: true,
                      });
                      setValueAsyncSelect('');
                      setIsEditing(false);

                      setSpeechTranscript('');
                    }}
                  >
                    <MdSearch size={20} />
                  </BtnFilter> */}
                </Form.Row>
              </Container.Header.Search>
              {exibeIdiomaCatalogo && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: 8,
                  }}
                >
                  <IdiomaCatalogoSelect
                    value={idiomaCatalogo}
                    onChange={(value) => dispatch(setIdiomaCatalogo(value))}
                  />
                </div>
              )}
            </Container.Header>

            <Wrapper>
              {!pageMaximize && (
                <>
                  {/**
                   * DOCK único: os trilhos ficam lado a lado e os painéis são
                   * posicionados em relação ao dock, abrindo sempre no mesmo
                   * lugar (à direita do último trilho) e no mesmo contexto de
                   * empilhamento — evita o painel de sistemas aparecer atrás
                   * da coluna de faces do sistema.
                   */}
                  <Menu>
                    {catalogo && (
                      <>
                        <Menu.BtnCollapse
                          type="button"
                          collapse={menuHidden ? 1 : 0}
                          aria-expanded={!menuHidden}
                          title={
                            menuHidden
                              ? `Abrir ${SYSTEM_TREE[idioma]}`
                              : `Fechar ${SYSTEM_TREE[idioma]}`
                          }
                          onClick={handleToggleMenuSistemas}
                        >
                          <MdAccountTree size={20} />
                          <span>{SYSTEM_TREE[idioma]}</span>
                          {menuHidden ? (
                            <MdChevronRight size={18} />
                          ) : (
                            <MdChevronLeft size={18} />
                          )}
                        </Menu.BtnCollapse>

                        {exibeColunaFaces && (
                          <Menu.BtnCollapse
                            type="button"
                            collapse={menuFacesHidden ? 1 : 0}
                            aria-expanded={!menuFacesHidden}
                            title={
                              menuFacesHidden
                                ? `Abrir ${SYSTEM_FACES[idioma]}`
                                : `Fechar ${SYSTEM_FACES[idioma]}`
                            }
                            onClick={handleToggleMenuFaces}
                          >
                            <MdLayers size={20} />
                            <span>{SYSTEM_FACES[idioma]}</span>
                            {menuFacesHidden ? (
                              <MdChevronRight size={18} />
                            ) : (
                              <MdChevronLeft size={18} />
                            )}
                          </Menu.BtnCollapse>
                        )}

                        <Menu.Content hidden={menuHidden}>
                          <Menu.Content.Header>
                            <strong>
                              <MdAccountTree size={16} />
                              {SYSTEM_TREE[idioma]}
                            </strong>
                            <button
                              type="button"
                              title={`Fechar ${SYSTEM_TREE[idioma]}`}
                              onClick={() => setMenuHidden(true)}
                            >
                              <MdClose size={18} />
                            </button>
                          </Menu.Content.Header>

                          <Menu.Content.Filter>
                            {catalogo.sistema && (
                              <span>
                                {catalogo.sistema.descricao}
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleFiltro(
                                      'FLT_IDS',
                                      catalogo.sistema.codiSist
                                    )
                                  }
                                >
                                  <MdClose size={12} />
                                </button>
                              </span>
                            )}

                            {catalogo.local && (
                              <span>
                                {catalogo.local.descricao}
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleFiltro(
                                      'FLT_IDL',
                                      catalogo.local.codiLoca
                                    )
                                  }
                                >
                                  <MdClose size={12} />
                                </button>
                              </span>
                            )}
                          </Menu.Content.Filter>

                          <Menu.Content.TreeView>
                            <TreeView data={catalogo} ref={refTtreeView} />
                          </Menu.Content.TreeView>

                          {/* <Menu.Content.File>
                          <h4>Anexos</h4>
                          <ul>
                            <li>
                              <a href="/#">NomeDaPeça.mp4</a>
                            </li>
                            <li>
                              <a href="/#">ManualDaPeça.pdf</a>
                            </li>
                            <li>
                              <a href="/#">DiagramaSecundario.pdf</a>
                            </li>
                          </ul>
                        </Menu.Content.File> */}
                        </Menu.Content>

                        {exibeColunaFaces && (
                          <Menu.Content hidden={menuFacesHidden}>
                            <Menu.Content.Header>
                              <strong>
                                <MdLayers size={16} />
                                {SYSTEM_FACES[idioma]}
                              </strong>
                              <button
                                type="button"
                                title={`Fechar ${SYSTEM_FACES[idioma]}`}
                                onClick={() => setMenuFacesHidden(true)}
                              >
                                <MdClose size={18} />
                              </button>
                            </Menu.Content.Header>

                            <Menu.Content.TreeView>
                              <SistemaFacesTree data={catalogo} hideHeader />
                            </Menu.Content.TreeView>
                          </Menu.Content>
                        )}
                      </>
                    )}
                  </Menu>
                </>
              )}

              <Content>
                <Content.ToolBar>
                  {catalogo && handleBreadcrumb(catalogo)}

                  {controle && (
                    <Content.ToolBar.DrawControl>
                      <button
                        type="button"
                        onClick={debounce(() => {
                          handlePageNav(-1);
                          handleScrollLinkTreeView();
                        }, 100)}
                      >
                        <MdChevronLeft size={20} />
                      </button>
                      <span>{shownPage}</span>
                      <button
                        type="button"
                        onClick={debounce(() => {
                          handlePageNav(1);
                          handleScrollLinkTreeView();
                        }, 100)}
                      >
                        <MdChevronRight size={20} />
                      </button>
                      <button ref={zoomInRef} type="button">
                        <MdZoomIn size={20} />
                      </button>
                      <button ref={zoomOutRef} type="button">
                        <MdZoomOut size={20} />
                      </button>
                      <button ref={zoomResetRef} type="button">
                        <MdYoutubeSearchedFor size={20} />
                      </button>
                      <button type="button" onClick={handleRedimensionar}>
                        {pageMaximize ? (
                          <MdFullscreenExit size={20} color="#ff6d3c" />
                        ) : (
                          <MdFullscreen size={20} />
                        )}
                      </button>
                      {/* <button type="button" onClick={handleImprimir}>
                        <MdPrint size={20} />
                      </button> */}
                      <button
                        type="button"
                        onClick={handlePDF}
                        disabled={loadingButtonPrint}
                      >
                        {loadingButtonPrint ? (
                          <GiSandsOfTime size={20} color="#ff6d3c" />
                        ) : (
                          <MdPrint size={20} />
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={handleMail}
                        disabled={loadingButtonMail}
                      >
                        {loadingButtonMail ? (
                          <GiSandsOfTime size={20} color="#ff6d3c" />
                        ) : (
                          <MdEmail size={20} />
                        )}
                      </button>
                    </Content.ToolBar.DrawControl>
                  )}
                </Content.ToolBar>

                {catalogo && handleContainer(catalogo)}
              </Content>
            </Wrapper>
          </>
        )}
      </Container>
    </>
  );
}

export default Classificacao;
